import React from 'react';
import { Diagram } from '../diagram';
import './ercotDiagram.scss';
import connections from './ERCOTconnections';

export class ErcotDiagram extends Diagram {
	parseConnectionData() {
		console.log(connections);
		this.setState({ allConnections: connections });
	}

    render() {
        const G = this.G;
        const style1 = { strokeLinecap:"round", strokeLinejoin:"round", fill:"none" };

        return (
            <div className='container ercot-diagram'>



<svg xmlns="http://www.w3.org/2000/svg"  
		 width="24.5in" height="14in" viewBox="0 0 1764 1008"
		 colorInterpolationFilters="sRGB" className="st91">
	
		
			
			
			
		
	

	<style type="text/css">
	
	</style>

	<defs id="Markers">
		<G id="lend28">
			<path d="M 0 -0.75 L 1.5 0 L 0 0.75 M 2 -0.75 L 2 0.75 " style={style1}/>
		</G>
		<marker id="mrkr28-219" className="st17" arrowtype="28" arrowsize="4" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(6.5) "/>
		</marker>
		<G id="lend29">
			<path
					d="M 2.25 0.75 C 1.83579 0.75 1.5 0.414214 1.5 0 1.5 -0.414214 1.83579 -0.75 2.25 -0.75 2.66421 -0.75 3 -0.414214 3 0 3 0.414214 2.66421 0.75 2.25 0.75 Z M 0 -0.75 L 1.5 0 L 0 0.75 M 1.5 0 L 0 0 "
					style={style1}/>
		</G>
		<marker id="mrkr29-221" className="st17" arrowtype="29" arrowsize="4" setback="19.5" refX="-19.5" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-6.5,-6.5) "/>
		</marker>
		<G id="lend25">
			<path d="M 1.5 -0.75 L 1.5 0.75 M 2.25 -0.75 L 2.25 0.75 " style={style1}/>
		</G>
		<marker id="mrkr25-432" className="st31" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-434" className="st31" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-521" className="st31" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-558" className="st36" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-560" className="st36" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-582" className="st36" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-589" className="st40" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-591" className="st40" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-624" className="st43" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-626" className="st43" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-737" className="st48" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr28-739" className="st48" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-750" className="st51" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr29-752" className="st51" arrowtype="29" arrowsize="2" setback="8.04" refX="-8.04" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-758" className="st51" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-790" className="st40" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-810" className="st57" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr28-812" className="st57" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-819" className="st57" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-863" className="st57" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-874" className="st48" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr28-913" className="st51" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-915" className="st51" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-946" className="st48" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr29-1075" className="st48" arrowtype="29" arrowsize="2" setback="7.8" refX="7.8" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr29-1082" className="st48" arrowtype="29" arrowsize="2" setback="8.04" refX="-8.04" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-1102" className="st43" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr28-1104" className="st43" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr29-1142" className="st43" arrowtype="29" arrowsize="2" setback="7.8" refX="7.8" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr29-1164" className="st43" arrowtype="29" arrowsize="2" setback="8.04" refX="-8.04" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr29-1299" className="st51" arrowtype="29" arrowsize="2" setback="7.8" refX="7.8" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-1336" className="st85" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr29-1338" className="st85" arrowtype="29" arrowsize="2" setback="8.04" refX="-8.04" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-2.68,-2.68) "/>
		</marker>
	</defs>
	<defs id="Filters">
		<filter id="filter_2">
			<feGaussianBlur stdDeviation="2"/>
		</filter>
	</defs>
	<G mid="0" index="1" groupcontext="foregroundPage">
		
			
		
		<title></title>
		
		
		
		
		
		
		
		
		
		
		<G id="shape1040-1" mid="1040" groupcontext="shape" layermember="8" transform="translate(463.74,-493.835)">
			<title></title>
			<G id="shadow1040-2" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1008 L369 1008 L369 714.37 L0 714.37 L0 1008 Z" className="st2"/>
			</G>
			<path d="M0 1008 L369 1008 L369 714.37 L0 714.37 L0 1008 Z" className="st3"/>
		</G>
		<G id="shape1-6" mid="1" groupcontext="shape" layermember="8" transform="translate(63,-552.335)" label="Federal Legislature" description="Federal legislatures define the scope of the various regulatory entities at the federal level. They may also define incentives for investment or other action within the industry and by consumers." >
			<title>Federal Legislature</title>
			<desc>Federal Legislature</desc>
			
				
			
			
			
			<G id="shadow1-7" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="79.5" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="19.41" y="981.9" className="st5" langid="1033">Federal<tspan
							x="10.4" dy="1.2em" className="st6">Legislature</tspan></text>			</G>
			<rect x="0" y="963" width="79.5" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="19.41" y="981.9" className="st8" langid="1033">Federal<tspan
						x="10.4" dy="1.2em" className="st6">Legislature</tspan></text>		</G>
		<G id="shape3-16" mid="3" groupcontext="shape" layermember="8" transform="translate(270,-808.835)" label="PUCT" description="In the U.S., regulatory commissions have been established by the 50 states and the District of Columbia for overseeing the operations and transactions of electric energy in their jurisdiction. These commissions may take different names like Public Utility Commissions (PUC), Public Service Commissions (PSC), corporation commissions, or commerce commissions. Areas which are considered outside of FERC's jurisdictional responsibility, for example retail electricity sales or regulation of distribution facilities, are regulated by the state regulators. In 1975, the Texas Legislature enacted the Public Utility Regulatory Act (PURA) and created the Public Utility Commission of Texas (PUCT) to provide statewide regulation of the rates and services of electric and telecommunications utilities." >
			<title>Public Utility Commission of Texas</title>
			<desc>PUCT</desc>
			
				
			
			
			
			<G id="shadow3-17" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="28.67" y="989.1" className="st5" langid="1033">PUCT</text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="28.67" y="989.1" className="st8" langid="1033">PUCT</text>		</G>
		<G id="shape8-24" mid="8" groupcontext="shape" layermember="8" transform="translate(459,-898.835)" label="Federal Hydro Generators" description="Federal hydro generators operate the federal hydro generation facilities in order to provide power (both real and reactive power) and reliability-related services. It monitors the status of the generating units and related equipment and reports their operating and availability status to Balancing Authority (BA) and Transmission Operator (TOP). " >
			<title>Federal Hydro Generators</title>
			<desc>Federal Hydro Generators</desc>
			
				
			
			
			
			<G id="shadow8-25" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="6.98" y="981.9" className="st5" langid="1033">Federal Hydro <tspan
							x="14.99" dy="1.2em" className="st6">Generators</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="6.98" y="981.9" className="st8" langid="1033">Federal Hydro <tspan
						x="14.99" dy="1.2em" className="st6">Generators</tspan></text>		</G>
		<G id="shape9-34" mid="9" groupcontext="shape" layermember="8" transform="translate(589.74,-907.835)" label="Public Hydro Generators" description="Public hydro generators operate the public hydro generation facilities in order to provide power (both real and reactive power) and reliability-related services. It monitors the status of the generating units and related equipment and reports their operating and availability status to Balancing Authority (BA) and Transmission Operator (TOP). " >
			<title>Public Hydro Generators</title>
			<desc>Public Hydro Generators</desc>
			
				
			
			
			
			<G id="shadow9-35" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="10.99" y="981.9" className="st5" langid="1033">Public Hydro <tspan
							x="14.99" dy="1.2em" className="st6">Generators</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="10.99" y="981.9" className="st8" langid="1033">Public Hydro <tspan
						x="14.99" dy="1.2em" className="st6">Generators</tspan></text>		</G>
		<G id="shape11-44" mid="11" groupcontext="shape" layermember="8" transform="translate(760.154,-205.835)" label="C and I Customers" description="The commercial sector includes retail, office, institutional, public and government facilities, and public services. Industrial customers, on the other hand, include manufacturing, mining, agriculture and construction industries." >
			<title>Commercial and Industrial Customers</title>
			<desc>C and I Customers</desc>
			
				
			
			
			
			<G id="shadow11-45" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="972" width="90" height="36" className="st4" style={{fill: 'inherit'}} />
				<text x="25.65" y="986.4" className="st5" langid="1033">C and I <tspan
							x="15.99" dy="1.2em" className="st6">Customers</tspan></text>			</G>
			<rect x="0" y="972" width="90" height="36" className="st7" style={{fill: 'inherit'}} />
			<text x="25.65" y="986.4" className="st8" langid="1033">C and I <tspan
						x="15.99" dy="1.2em" className="st6">Customers</tspan></text>		</G>
		<G id="shape12-54" mid="12" groupcontext="shape" layermember="8" transform="translate(603,-196.835)" label="Residential Customers" description="Residential customers include single-family homes and multi-family housing. " >
			<title>Residential Customers</title>
			<desc>Residential Customers</desc>
			
				
			
			
			
			<G id="shadow12-55" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="972" width="90" height="36" className="st4" style={{fill: 'inherit'}} />
				<text x="15.32" y="986.4" className="st5" langid="1033">Residential <tspan
							x="15.99" dy="1.2em" className="st6">Customers</tspan></text>			</G>
			<rect x="0" y="972" width="90" height="36" className="st7" style={{fill: 'inherit'}} />
			<text x="15.32" y="986.4" className="st8" langid="1033">Residential <tspan
						x="15.99" dy="1.2em" className="st6">Customers</tspan></text>		</G>
		<G id="shape20-64" mid="20" groupcontext="shape" layermember="8" transform="translate(288,-403.835)" label="Independent Market Monitor" description="Independent Market Monitor (IMM) is an organization that provides impartial market monitoring services for the wholesale electricity market. Their responsibilities include monitoring of compliance with market rules, developing metrics and tools for analysis, evaluating the market performance, identifying and investigating anti-competitive behavior, collecting data and preparing reports. Potomac Economics serves as the Independent Market Monitor for the wholesale electricity markets operated by the Electric Reliability Council of Texas (ERCOT). It identifies conduct by market participants or market rules that compromise the efficiency or distort the outcomes of the markets. It also issues periodic reports providing an independent assessment of the competitive performance and operational efficiency of the market. 
Reference:
Potomac Economics, &quot;About Us&quot;, [Online]. Available: https://www.potomaceconomics.com/about-us/. [Accessed: 06-Jan-2020]." >
			<title>Independent Market Monitor</title>
			<desc>Independent Market Monitor</desc>
			
				
			
			
			
			<G id="shadow20-65" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="11.63" y="981.9" className="st5" langid="1033">Independent <tspan
							x="4.99" dy="1.2em" className="st6">Market Monitor</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="11.63" y="981.9" className="st8" langid="1033">Independent <tspan
						x="4.99" dy="1.2em" className="st6">Market Monitor</tspan></text>		</G>
		<G id="shape21-74" mid="21" groupcontext="shape" layermember="8" transform="translate(81,-448.835)" label="Power Market Administration" description="Power Market Administrations (PMA), interchangeably called Power Marketing Agencies, are officially federal agencies within the Department of Energy which market wholesale power produced by federally owned and operated hydroelectric dams. In the U.S. there are four PMAs which operate in total over 33 states." >
			<title>Power Market Administration</title>
			<desc>Power Market Administration</desc>
			
				
			
			
			
			<G id="shadow21-75" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="7.99" y="981.9" className="st5" langid="1033">Power Market <tspan
							x="6.98" dy="1.2em" className="st6">Administration</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="7.99" y="981.9" className="st8" langid="1033">Power Market <tspan
						x="6.98" dy="1.2em" className="st6">Administration</tspan></text>		</G>
		<G id="shape22-84" mid="22" groupcontext="shape" layermember="8" transform="translate(288,-556.835)" label="Federal Regulator" description="The Federal Regulators entity class primarily consists of the Federal Energy Regulatory Commission (FERC), Environmental Protection Agency (EPA), Nuclear Regulatory Commission (NRC), Department of Energy (DOE), and Commodity Futures Trading Commission (CFTC). FERC is an independent agency within the U.S. Department of Energy (DOE) which has regulatory authority over interstate transmission. It regulates sales of wholesale electricity in interstate commerce, as well as provides oversight of regional wholesale markets. It also establishes financial rules for all entities of the bulk power system, such as the firewall rules between financial activities and transmission system operations. Other responsibilities include licensing and inspecting hydroelectric projects and overseeing environmental matters related to them and protecting reliability of high voltage interstate transmission by enforcing reliability standards." >
			<title>Federal Regulator</title>
			<desc>Federal Regulator</desc>
			
				
			
			
			
			<G id="shadow22-85" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="24.66" y="981.9" className="st5" langid="1033">Federal <tspan
							x="18.98" dy="1.2em" className="st6">Regulator</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="24.66" y="981.9" className="st8" langid="1033">Federal <tspan
						x="18.98" dy="1.2em" className="st6">Regulator</tspan></text>		</G>
		<G id="shape23-94" mid="23" groupcontext="shape" layermember="8" transform="translate(81,-808.835)" label="Texas Legislature" description="State legislatures play one of the key roles in developing policies, providing recommendations, or in some other cases signaling support or opposition to certain policies and initiatives, and also urging federal action if needed. They can provide funding, incentives or mandates for advancing grid technologies. For example, state legislature may establish incentives or renewable portfolio standards that apply to all utilities within the state. They establish the regulatory construct for Investor Owned Utilities (IOUs), and sometimes other utilities, within their state, which is then applied by the state-level utility regulatory body." >
			<title>Texas Legislature</title>
			<desc>Texas Legislature</desc>
			
				
			
			
			
			<G id="shadow23-95" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="28.66" y="981.9" className="st5" langid="1033">Texas <tspan
							x="15.65" dy="1.2em" className="st6">Legislature</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="28.66" y="981.9" className="st8" langid="1033">Texas <tspan x="15.65"
						dy="1.2em" className="st6">Legislature</tspan></text>		</G>
		<G id="shape31-104" mid="31" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(1304.06,-144)">
			<title></title>
			<rect x="0" y="775.755" width="132.75" height="232.245" className="st9"/>
		</G>
		<G id="shape47-106" mid="47" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
				transform="translate(1310.81,-269.228)">
			<title></title>
			<desc>Entity Class</desc>
			
			
			<path d="M72 981.75 L0 981.75 L0 1008 L72 1008 L72 981.75 Z" className="st10"/>
			<text x="9.6" y="997.87" className="st11" langid="1033">Entity Class</text>		</G>
		<G id="group48-109" transform="translate(1310.81,-334.805)" mid="48" groupcontext="group"
				layermember="1;2;3;4;5;6;7;8">
			<title></title>
			<G id="shape49-110" mid="49" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(17.3171,-3.5974)">
				<title></title>
				<path d="M0 1008 L23.57 1008" className="st12"/>
			</G>
			<G id="shape50-113" mid="50" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(5.4116,0)">
				<title></title>
				<path d="M0 1000.81 L0 1008" className="st12"/>
			</G>
			<G id="shape51-116" mid="51" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(5.4116,0)">
				<title></title>
				<path d="M0 1008 L0 1000.81" className="st12"/>
			</G>
			<G id="shape52-119" mid="52" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(-4.996E-015,-3.5974)">
				<title></title>
				<path d="M10.82 1008 L0 1008" className="st12"/>
			</G>
			<G id="shape53-122" mid="53" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(-4.996E-015,-3.5974)">
				<title></title>
				<path d="M0 1008 L10.82 1008" className="st12"/>
			</G>
			<G id="shape54-125" mid="54" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(10.8232,-1.07922)">
				<title></title>
				<ellipse cx="2.88618" cy="1005.12" rx="2.88618" ry="2.87792" className="st13"/>
				<ellipse cx="2.88618" cy="1005.12" rx="2.88618" ry="2.87792" className="st12"/>
			</G>
		</G>
		<G id="group55-128" transform="translate(1310.81,-322.332)" mid="55" groupcontext="group"
				layermember="1;2;3;4;5;6;7;8">
			<title></title>
			<G id="shape56-129" mid="56" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(17.3171,-3.47749)">
				<title></title>
				<path d="M0 1008 L18.76 1008" className="st12"/>
			</G>
			<G id="shape57-132" mid="57" groupcontext="shape" layermember="1;2;3;4;5;6;7;8">
				<title></title>
				<path d="M10.82 1004.52 L0 1008" className="st12"/>
			</G>
			<G id="shape58-135" mid="58" groupcontext="shape" layermember="1;2;3;4;5;6;7;8">
				<title></title>
				<path d="M0 1008 L10.82 1004.52" className="st12"/>
			</G>
			<G id="shape59-138" mid="59" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(2.69784E-014,-3.47749)">
				<title></title>
				<path d="M10.82 1008 L0 1004.4" className="st12"/>
			</G>
			<G id="shape60-141" mid="60" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(2.69784E-014,-3.47749)">
				<title></title>
				<path d="M0 1004.4 L10.82 1008" className="st12"/>
			</G>
			<G id="shape61-144" mid="61" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(2.69784E-014,-3.47749)">
				<title></title>
				<path d="M10.82 1008 L0 1008" className="st12"/>
			</G>
			<G id="shape62-147" mid="62" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(2.69784E-014,-3.47749)">
				<title></title>
				<path d="M0 1008 L10.82 1008" className="st12"/>
			</G>
			<G id="shape63-150" mid="63" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(10.8232,-0.959308)">
				<title></title>
				<ellipse cx="2.88618" cy="1005.12" rx="2.88618" ry="2.87792" className="st13"/>
				<ellipse cx="2.88618" cy="1005.12" rx="2.88618" ry="2.87792" className="st12"/>
			</G>
		</G>
		<G id="group64-153" transform="translate(1310.71,-347.399)" mid="64" groupcontext="group"
				layermember="1;2;3;4;5;6;7;8">
			<title></title>
			<G id="shape65-154" mid="65" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(0,-3.5974)">
				<title></title>
				<path d="M0 1008 L36.2 1008" className="st12"/>
			</G>
			<G id="shape66-157" mid="66" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(10.9435,0)">
				<title></title>
				<path d="M0 1000.93 L0 1008" className="st12"/>
			</G>
			<G id="shape67-160" mid="67" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(10.9435,0)">
				<title></title>
				<path d="M0 1008 L0 1000.93" className="st12"/>
			</G>
			<G id="shape68-163" mid="68" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(14.1904,0)">
				<title></title>
				<path d="M0 1000.93 L0 1008" className="st12"/>
			</G>
			<G id="shape69-166" mid="69" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(14.1904,0)">
				<title></title>
				<path d="M0 1008 L0 1000.93" className="st12"/>
			</G>
		</G>
		<G id="group70-169" transform="translate(1310.81,-309.858)" mid="70" groupcontext="group"
				layermember="1;2;3;4;5;6;7;8">
			<title></title>
			<G id="shape71-170" mid="71" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(14.25,0)">
				<title></title>
				<path d="M0 1008 L0 1000.93" className="st12"/>
			</G>
			<G id="shape72-173" mid="72" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(0,-3.47749)">
				<title></title>
				<path d="M0 1008 L22.97 1008" className="st12"/>
			</G>
			<G id="shape73-176" mid="73" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(0.120258,0)">
				<title></title>
				<path d="M10.82 1004.52 L0 1008" className="st12"/>
			</G>
			<G id="shape74-179" mid="74" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(0.120258,0)">
				<title></title>
				<path d="M0 1008 L10.82 1004.52" className="st12"/>
			</G>
			<G id="shape75-182" mid="75" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(0.120258,-3.47749)">
				<title></title>
				<path d="M10.82 1008 L0 1004.4" className="st12"/>
			</G>
			<G id="shape76-185" mid="76" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(0.120258,-3.47749)">
				<title></title>
				<path d="M0 1004.4 L10.82 1008" className="st12"/>
			</G>
		</G>
		<G id="shape77-188" mid="77" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
				transform="translate(1360.5,-344.361)">
			<title></title>
			<desc>only 1</desc>
			
			
			<rect x="0" y="993.625" width="44.4643" height="14.375" className="st14" style={{fill: 'inherit'}} />
			<text x="4" y="1003.81" className="st11" langid="1033">only 1</text>		</G>
		<G id="shape78-191" mid="78" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(1360.5,-329.25)">
			<title></title>
			<desc>zero or 1</desc>
			
			
			<rect x="0" y="993.625" width="57" height="14.375" className="st14" style={{fill: 'inherit'}} />
			<text x="4" y="1003.81" className="st11" langid="1033">zero or 1</text>		</G>
		<G id="shape79-194" mid="79" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
				transform="translate(1360.5,-318.682)">
			<title></title>
			<desc>zero or more</desc>
			
			
			<rect x="0" y="993.625" width="79.5" height="14.375" className="st14" style={{fill: 'inherit'}} />
			<text x="4" y="1003.81" className="st11" langid="1033">zero or more</text>		</G>
		<G id="shape80-197" mid="80" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
				transform="translate(1360.5,-306.208)">
			<title></title>
			<desc>1 or more</desc>
			
			
			<rect x="0" y="993.625" width="63.75" height="14.375" className="st14" style={{fill: 'inherit'}} />
			<text x="4" y="1003.81" className="st11" langid="1033">1 or more</text>		</G>
		<G id="shape81-200" mid="81" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(1353.8,-358)">
			<title></title>
			<desc>Key</desc>
			
			
			<rect x="0" y="988" width="49.4891" height="20" className="st14" style={{fill: 'inherit'}} />
			<text x="14.41" y="1001.6" className="st8" langid="1033"><tspan className="st15">Key</tspan></text>		</G>
		<G id="shape83-204" mid="83" groupcontext="shape" layermember="8" transform="translate(423,-222.167)" label="Aggregators" description="An aggregator acts as a middle-man between utility and users and can negotiate with the utility on behalf of the customers. They may provide technology for performing Demand Response (DR) or better management of DER." >
			<title>Aggregators</title>
			<desc>Aggregators</desc>
			
				
			
			
			
			<G id="shadow83-205" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="972" width="90" height="36" className="st4" style={{fill: 'inherit'}} />
				<text x="12.31" y="993.6" className="st5" langid="1033">Aggregators</text>			</G>
			<rect x="0" y="972" width="90" height="36" className="st7" style={{fill: 'inherit'}} />
			<text x="12.31" y="993.6" className="st8" langid="1033">Aggregators</text>		</G>
		<G id="group85-212" transform="translate(1308.97,-144)" mid="85" groupcontext="group" layermember="1;2;3;4;5;6;7;8">
			<title></title>
			<G id="shape32-213" mid="32" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(27.9643,-98.8929)">
				<title></title>
				<path d="M0 1008 L53.46 1008" className="st16"/>
			</G>
			<G id="shape33-222" mid="33" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(0.857143,-89.1429)">
				<title></title>
				<desc>A</desc>
				
				
				<path d="M26.94 989.73 L0 989.73 L0 1008 L26.94 1008 L26.94 989.73 Z" className="st10"/>
				<text x="10.13" y="1001.87" className="st11" langid="1033">A</text>			</G>
			<G id="shape34-225" mid="34" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(96,-89.1429)">
				<title></title>
				<desc>B</desc>
				
				
				<path d="M26.94 989.73 L0 989.73 L0 1008 L26.94 1008 L26.94 989.73 Z" className="st10"/>
				<text x="10.13" y="1001.87" className="st11" langid="1033">B</text>			</G>
			<G id="shape35-228" mid="35" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(41.1429,-96)">
				<title></title>
				<desc>relation&#62;</desc>
				
				
				<rect x="0" y="992.429" width="39.3036" height="15.5714" className="st14" style={{fill: 'inherit'}} />
				<text x="4.2" y="1002.61" className="st18" langid="1033">relation&#62;</text>			</G>
			<G id="shape36-231" mid="36" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(24.75,-77.25)">
				<title></title>
				<desc>A acts on or for B</desc>
				
				
				<rect x="0" y="994.357" width="77.8214" height="13.6429" className="st14" style={{fill: 'inherit'}} />
				<text x="8.01" y="1003.58" className="st18" langid="1033">A acts on or for B</text>			</G>
			<G id="shape37-234" mid="37" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(27.1071,-59.4643)">
				<title></title>
				<path d="M0 1008 L53.46 1008" className="st16"/>
			</G>
			<G id="shape38-241" mid="38" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(0,-49.7143)">
				<title></title>
				<desc>A</desc>
				
				
				<path d="M26.94 989.73 L0 989.73 L0 1008 L26.94 1008 L26.94 989.73 Z" className="st10"/>
				<text x="10.13" y="1001.87" className="st11" langid="1033">A</text>			</G>
			<G id="shape39-244" mid="39" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(95.1429,-49.7143)">
				<title></title>
				<desc>B</desc>
				
				
				<path d="M26.94 989.73 L0 989.73 L0 1008 L26.94 1008 L26.94 989.73 Z" className="st10"/>
				<text x="10.13" y="1001.87" className="st11" langid="1033">B</text>			</G>
			<G id="shape40-247" mid="40" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(40.2857,-56.5714)">
				<title></title>
				<desc>&#60;relation</desc>
				
				
				<rect x="0" y="992.429" width="39.3036" height="15.5714" className="st14" style={{fill: 'inherit'}} />
				<text x="4.2" y="1002.61" className="st18" langid="1033">&#60;relation</text>			</G>
			<G id="shape41-250" mid="41" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(24,-40.5)">
				<title></title>
				<desc>B acts on or for A</desc>
				
				
				<rect x="0" y="994.357" width="77.8214" height="13.6429" className="st14" style={{fill: 'inherit'}} />
				<text x="8.01" y="1003.58" className="st18" langid="1033">B acts on or for A</text>			</G>
			<G id="shape42-253" mid="42" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(27.1071,-21.75)">
				<title></title>
				<path d="M0 1008 L53.46 1008" className="st16"/>
			</G>
			<G id="shape43-260" mid="43" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(0,-12)">
				<title></title>
				<desc>A</desc>
				
				
				<path d="M26.94 989.73 L0 989.73 L0 1008 L26.94 1008 L26.94 989.73 Z" className="st10"/>
				<text x="10.13" y="1001.87" className="st11" langid="1033">A</text>			</G>
			<G id="shape44-263" mid="44" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(95.1429,-12)">
				<title></title>
				<desc>B</desc>
				
				
				<path d="M26.94 989.73 L0 989.73 L0 1008 L26.94 1008 L26.94 989.73 Z" className="st10"/>
				<text x="10.13" y="1001.87" className="st11" langid="1033">B</text>			</G>
			<G id="shape45-266" mid="45" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
					transform="translate(37.7045,-18.1364)">
				<title></title>
				<desc>&#60;relation&#62;</desc>
				
				
				<rect x="0" y="992.429" width="44.4643" height="15.5714" className="st14" style={{fill: 'inherit'}} />
				<text x="4.44" y="1002.61" className="st18" langid="1033">&#60;relation&#62;</text>			</G>
			<G id="shape46-269" mid="46" groupcontext="shape" layermember="1;2;3;4;5;6;7;8" transform="translate(23.25,0)">
				<title></title>
				<desc>bilateral relation</desc>
				
				
				<rect x="0" y="994.357" width="77.8214" height="13.6429" className="st14" style={{fill: 'inherit'}} />
				<text x="10.67" y="1003.58" className="st18" langid="1033">bilateral relation</text>			</G>
		</G>
		<G id="group1015-272" transform="translate(1264.51,-413.575)" mid="1015" groupcontext="group" layermember="8">
			<title></title>
			<G id="shape1016-273" mid="1016" groupcontext="shape" layermember="8" transform="translate(0,-95.9667)">
				<title></title>
				<G id="shadow1016-274" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="993.959" width="57" height="14.0406" className="st19"/>
				</G>
				<rect x="0" y="993.959" width="57" height="14.0406" className="st20"/>
			</G>
			<G id="shape1017-278" mid="1017" groupcontext="shape" layermember="8" transform="translate(0,-72.5105)">
				<title></title>
				<G id="shadow1017-279" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="993.959" width="57" height="14.0406" className="st19"/>
				</G>
				<rect x="0" y="993.959" width="57" height="14.0406" className="st21"/>
			</G>
			<G id="shape1018-283" mid="1018" groupcontext="shape" layermember="8" transform="translate(0,-27.1793)">
				<title></title>
				<G id="shadow1018-284" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="993.959" width="57" height="14.0406" className="st19"/>
				</G>
				<rect x="0" y="993.959" width="57" height="14.0406" className="st22"/>
			</G>
			<G id="shape1019-288" mid="1019" groupcontext="shape" layermember="8" transform="translate(1.48571,-139.384)">
				<title></title>
				<G id="shadow1019-289" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="993.959" width="57" height="14.0406" className="st19"/>
				</G>
				<rect x="0" y="993.959" width="57" height="14.0406" className="st23"/>
			</G>
			<G id="shape1020-293" mid="1020" groupcontext="shape" layermember="8" transform="translate(0.0486256,-4.58053)">
				<title></title>
				<G id="shadow1020-294" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="993.959" width="57" height="14.0406" className="st19"/>
				</G>
				<rect x="0" y="993.959" width="57" height="14.0406" className="st24"/>
			</G>
			<G id="shape1021-298" mid="1021" groupcontext="shape" layermember="8" transform="translate(0,-48.4408)">
				<title></title>
				<G id="shadow1021-299" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="993.959" width="57" height="14.0406" className="st19"/>
				</G>
				<rect x="0" y="993.959" width="57" height="14.0406" className="st25"/>
			</G>
			<G id="shape1022-303" mid="1022" groupcontext="shape" layermember="8" transform="translate(1.48571,-117.425)">
				<title></title>
				<G id="shadow1022-304" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="993.959" width="57" height="14.0406" className="st19"/>
				</G>
				<rect x="0" y="993.959" width="57" height="14.0406" className="st26"/>
			</G>
			<G id="shape1023-308" mid="1023" groupcontext="shape" layermember="8" transform="translate(58.4857,-24.5272)">
				<title></title>
				<desc>Energy and services</desc>
				
				
				<rect x="0" y="993.082" width="132.75" height="14.9182" className="st27" style={{fill: 'inherit'}} />
				<text x="4" y="1004.14" className="st28" langid="1033">Energy and services</text>			</G>
			<G id="shape1024-311" mid="1024" groupcontext="shape" layermember="8" transform="translate(58.4857,-3.44537)">
				<title></title>
				<desc>Control and coordination</desc>
				
				
				<rect x="0" y="993.082" width="132.75" height="14.9182" className="st27" style={{fill: 'inherit'}} />
				<text x="4" y="1004.14" className="st28" langid="1033">Control and coordination</text>			</G>
			<G id="shape1025-314" mid="1025" groupcontext="shape" layermember="8" transform="translate(58.4857,-48.4454)">
				<title></title>
				<desc>State regulation</desc>
				
				
				<rect x="0" y="993.082" width="132.75" height="14.9182" className="st27" style={{fill: 'inherit'}} />
				<text x="4" y="1004.14" className="st28" langid="1033">State regulation</text>			</G>
			<G id="shape1026-317" mid="1026" groupcontext="shape" layermember="8" transform="translate(58.4857,-72.4863)">
				<title></title>
				<desc>Federal regulation</desc>
				
				
				<rect x="0" y="993.082" width="132.75" height="14.9182" className="st27" style={{fill: 'inherit'}} />
				<text x="4" y="1004.14" className="st28" langid="1033">Federal regulation</text>			</G>
			<G id="shape1027-320" mid="1027" groupcontext="shape" layermember="8" transform="translate(58.4857,-93.5067)">
				<title></title>
				<desc>Retail</desc>
				
				
				<rect x="0" y="993.625" width="132.75" height="14.375" className="st27" style={{fill: 'inherit'}} />
				<text x="4" y="1004.41" className="st28" langid="1033">Retail</text>			</G>
			<G id="shape1028-323" mid="1028" groupcontext="shape" layermember="8" transform="translate(58.4857,-118.966)">
				<title></title>
				<desc>Market interaction</desc>
				
				
				<rect x="0" y="993.082" width="132.75" height="14.9182" className="st27" style={{fill: 'inherit'}} />
				<text x="4" y="1004.14" className="st28" langid="1033">Market interaction</text>			</G>
			<G id="shape1029-326" mid="1029" groupcontext="shape" layermember="8" transform="translate(58.4857,-138.507)">
				<title></title>
				<desc>Reliability coordination</desc>
				
				
				<rect x="0" y="993.082" width="132.75" height="14.9182" className="st27" style={{fill: 'inherit'}} />
				<text x="4" y="1004.14" className="st28" langid="1033">Reliability coordination</text>			</G>
		</G>
		<G id="shape1030-329" mid="1030" groupcontext="shape" layermember="1;2;3;4;5;6;7;8"
				transform="translate(1260,-412.875)">
			<title></title>
			<G id="shadow1030-330" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="844.875" width="207" height="163.125" className="st4"/>
			</G>
			<rect x="0" y="844.875" width="207" height="163.125" className="st29"/>
		</G>
		<G id="shape1031-334" mid="1031" groupcontext="shape" layermember="8" transform="translate(63,-669.898)" label="NERC" description="The North American Electric Reliability Corporation (NERC) is a not-for-profit international regulatory authority tasked with assuring reliability and security of the bulk power system in North America. NERC's area of responsibility covers the continental U.S., Canada as well as the northern portion of Baja California, Mexico. Currently, NERC is designated as the U.S. government's Electric Reliability Organization (ERO) subject to oversight by the FERC. Some of the responsibilities of NERC include development and enforcement of reliability standards, annual assessment of reliability, monitoring of bulk power system as well as education, training and certification of industry personnel. 
Reference:
NERC, &quot;About NERC&quot;, 2017, [Online]. Available: https://www.nerc.com/AboutNERC/Pages/default.aspx. [Accessed: 06-Jan-2020]." >
			<title>North American Electric Reliability Corporation</title>
			<desc>NERC</desc>
			
				
			
			
			
			<G id="shadow1031-335" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="28" y="989.1" className="st5" langid="1033">NERC</text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="28" y="989.1" className="st8" langid="1033">NERC</text>		</G>
		<G id="shape1032-342" mid="1032" groupcontext="shape" layermember="8" transform="translate(261,-668.773)" label="Texas RE" description="NERC delegates authority of compliance monitoring and enforcement to Regional Reliability Entities (RREs) and oversees their operations. Members of these RREs come from the different segments of the electric power industry, like federal power agencies, IOUs, co-ops, munis, PUDs, IPP, power marketers and end-use customers. 
Texas Reliability Entity, Inc. (Texas RE) is a Texas 501(c)(3) non-profit corporation that is the RRE for the area of Texas served by the ERCOT. Through a Delegation Agreement with the NERC, which is approved by the FERC, Texas RE is authorized to do the following in the ERCOT region- (i) develop, monitor, assess, and enforce compliance with NERC Reliability Standards, (ii) develop regional standards, and (iii) assess and periodically report on the reliability and adequacy of the bulk power system (BPS). In addition, Texas RE serves as the Public Utility Commission of Texas's Reliability Monitor for the ERCOT region. 
Reference:
Texas Reliability Entity, &quot;About Us&quot;, 2019, [Online]. Available: https://www.texasre.org/Pages/About-Us.aspx. [Accessed: 06-Jan-2020]." >
			<title>Texas Reliability Entity</title>
			<desc>Texas RE</desc>
			
				
			
			
			
			<G id="shadow1032-343" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="18.66" y="989.1" className="st5" langid="1033">Texas RE</text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="18.66" y="989.1" className="st8" langid="1033">Texas RE</text>		</G>
		<G id="shape1033-350" mid="1033" groupcontext="shape" layermember="8" transform="translate(166.74,-313.835)" label="Neighboring Grids with DC Ties" description="It refers to the entity class of the neighboring grids with which ERCOT is not synchronously connected but connected through DC ties." >
			<title>Neighboring Grids with DC Ties</title>
			<desc>Neighboring Grids with DC Ties</desc>
			
				
			
			
			
			<G id="shadow1033-351" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="12.64" y="974.7" className="st5" langid="1033">Neighboring <tspan
							x="7.99" dy="1.2em" className="st6">Grids with DC </tspan><tspan x="33.66" dy="1.2em" className="st6">Ties</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="12.64" y="974.7" className="st8" langid="1033">Neighboring <tspan
						x="7.99" dy="1.2em" className="st6">Grids with DC </tspan><tspan x="33.66" dy="1.2em" className="st6">Ties</tspan></text>		</G>
		<G id="shape1034-362" mid="1034" groupcontext="shape" layermember="8" transform="translate(1098,-588.335)" label="Bulk Power Marketers, Arbitragers" description="Power Marketers usually own or control generation or transmission facilities but act as intermediaries by purchasing electricity from numerous utilities and reselling it to other utilities or distribution providers. By taking advantage of the disparities in prices and determining their best combination, they can provide better prices to their customers while making a profit for themselves. Registration with the FERC is necessary to obtain status as a power marketer. " >
			<title>Bulk Power Marketers, Arbitragers</title>
			<desc>Bulk Power Marketers, Arbitragers</desc>
			
				
			
			
			
			<G id="shadow1034-363" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="14.65" y="974.7" className="st5" langid="1033">Bulk Power <tspan
							x="16.66" dy="1.2em" className="st6">Marketers</tspan>, <tspan x="15.66" dy="1.2em" className="st6">Arbitragers</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="14.65" y="974.7" className="st8" langid="1033">Bulk Power <tspan
						x="16.66" dy="1.2em" className="st6">Marketers</tspan>, <tspan x="15.66" dy="1.2em" className="st6">Arbitragers</tspan></text>		</G>
		<G id="shape1035-374" mid="1035" groupcontext="shape" layermember="8" transform="translate(756.54,-894.335)" label="Merchant Generators" description="Merchant-owned generation facilities that provide power (both real and reactive power) and reliability-related services." >
			<title>Merchant Generators</title>
			<desc>Merchant Generators</desc>
			
				
			
			
			
			<G id="shadow1035-375" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="19.99" y="981.9" className="st5" langid="1033">Merchant <tspan
							x="14.99" dy="1.2em" className="st6">Generators</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="19.99" y="981.9" className="st8" langid="1033">Merchant <tspan
						x="14.99" dy="1.2em" className="st6">Generators</tspan></text>		</G>
		<G id="shape1041-384" mid="1041" groupcontext="shape" layermember="8" transform="translate(900,-780.565)" label="Distributed Generator" description="An electrical generating facility located at a customer's point of delivery (point of common coupling) ten megawatts (MW) or less and connected at a voltage less than or equal to 60 kilovolts (kV) which may be connected in parallel operation to the utility system." >
			<title>Distributed Generator (DG)</title>
			<desc>Distributed Generator</desc>
			
				
			
			
			
			<G id="shadow1041-385" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="16.32" y="981.9" className="st5" langid="1033">Distributed <tspan
							x="17.99" dy="1.2em" className="st6">Generator </tspan> </text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="16.32" y="981.9" className="st8" langid="1033">Distributed <tspan
						x="17.99" dy="1.2em" className="st6">Generator </tspan> </text>		</G>
		<G id="shape1044-394" mid="1044" groupcontext="shape" layermember="8" transform="translate(954,-433.377)" label="Other Transmission Operators" description="Other Transmission Operator (TOP) refers to the entity class that operates the transmission facilities that are physically connected to ERCOT's transmission system. A TOP monitors the status of and deploys transmission assets (like transmission lines, protection systems) and reactive resources, adjusts flow control devices, and provides telemetry. It also develops system limitations and operates its system within the specified limits. Development and implementation of emergency procedures as well as system restoration plans are also performed by TOP." >
			<title>Other Transmission Operators</title>
			<desc>Other Transmission Operators</desc>
			
				
			
			
			
			<G id="shadow1044-395" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="29.99" y="974.7" className="st5" langid="1033">Other <tspan
							x="9.32" dy="1.2em" className="st6">Transmission </tspan><tspan x="18.32" dy="1.2em" className="st6">Operators</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="29.99" y="974.7" className="st8" langid="1033">Other <tspan x="9.32"
						dy="1.2em" className="st6">Transmission </tspan><tspan x="18.32" dy="1.2em" className="st6">Operators</tspan></text>		</G>
		<G id="shape1045-406" mid="1045" groupcontext="shape" layermember="8" transform="translate(846,-318.335)" label="Competitive Retailer" description="Competitive Retailer can be an Opt In Entity i.e. Municipally Owned Utility (MOU) or an Electric Cooperative (EC) that offers customer choice and sells electric energy at retail in the restructured electric power market in Texas, or a Retail Electric Provider (REP). Competitive Retailer (CR) is assigned to the Electric Service Identifier (ESI ID) in ERCOT's database, and there can be no more than one CR of Record assigned to an ESI ID for any given time period." >
			<title>Competitive Retailer</title>
			<desc>Competitive Retailer</desc>
			
				
			
			
			
			<G id="shadow1045-407" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="13.32" y="981.9" className="st5" langid="1033">Competitive <tspan
							x="24.33" dy="1.2em" className="st6">Retailer</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="13.32" y="981.9" className="st8" langid="1033">Competitive <tspan
						x="24.33" dy="1.2em" className="st6">Retailer</tspan></text>		</G>
		<G id="shape1046-416" mid="1046" groupcontext="shape" layermember="8" transform="translate(605.375,-363.335)" label="Distribution Provider" description="An entity class that owns or operates a distribution system for the delivery of energy from the transmission system to customers." >
			<title>Distribution Provider</title>
			<desc>Distribution Provider</desc>
			
				
			
			
			
			<G id="shadow1046-417" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="14.99" y="981.9" className="st5" langid="1033">Distribution <tspan
							x="22.66" dy="1.2em" className="st6">Provider</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="14.99" y="981.9" className="st8" langid="1033">Distribution <tspan
						x="22.66" dy="1.2em" className="st6">Provider</tspan></text>		</G>
		<G id="shape1048-426" mid="1048" groupcontext="shape" layermember="1" transform="translate(142.5,-568.085)">
			<title></title>
			<path d="M0 1001.25 L88.5 1001.25 A3 3 0 1 1 94.5 1001.25 L96.24 1001.25 A3 3 0 0 1 102.24 1001.25 L118.5 1001.25 L118.5
						 996.75 L145.5 996.75" className="st30"/>
		</G>
		<G id="shape1049-435" mid="1049" groupcontext="shape" layermember="8" transform="translate(724.74,-723.335)" label="Transmission Service Provider" description="Transmission Service Provider (TSP) processes transmission service requests received from Generator Owners (GO), Load Serving Entities (LSE) and Purchase Selling Entities (PSE). The Transmission Owner's (TO's) tariff and the operating limits provided by the Reliability Coordinator (RC) are considered when processing such requests. TSP also allocates transmission losses between the Balancing Aauthorities (BA) and arranges for transmission loss compensation. In other words, it is an entity class under the jurisdiction of the PUCT that owns or operates transmission facilities used for the transmission of electricity and provides transmission service in the ERCOT Transmission Grid." >
			<title>ERCOT - Transmission Service Provider</title>
			<desc>Transmission Service Provider</desc>
			
				
			
			
			
			<G id="shadow1049-436" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="9.32" y="974.7" className="st5" langid="1033">Transmission <tspan
							x="24.99" dy="1.2em" className="st6">Service </tspan><tspan x="22.66" dy="1.2em" className="st6">Provider</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="9.32" y="974.7" className="st8" langid="1033">Transmission <tspan
						x="24.99" dy="1.2em" className="st6">Service </tspan><tspan x="22.66" dy="1.2em" className="st6">Provider</tspan></text>		</G>
		<G id="shape1050-447" mid="1050" groupcontext="shape" layermember="8" transform="translate(602.94,-619.835)" label="Balancing Authority" description="Balancing Authority (BA) is the entity which is responsible for maintaining balance between generation, load, and interchange in real-time. Its contribution is critical to maintaining the desired interconnection frequency. On a high-level the tasks of a BA include controlling resources within its area, performing unit commitment (UC) and economic dispatch (ED), deploying regulation service as needed, approving and implementing interchange with adjoining balancing authorities, and providing planned schedules to the Reliability Coordinator (RC). During any emergency event, it works with the RC to implement emergency procedures like demand-side management programs, load shedding etc.     " >
			<title>ERCOT - Balancing Authority</title>
			<desc>Balancing Authority</desc>
			
				
			
			
			
			<G id="shadow1050-448" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="18.65" y="981.9" className="st5" langid="1033">Balancing <tspan
							x="21.32" dy="1.2em" className="st6">Authority</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="18.65" y="981.9" className="st8" langid="1033">Balancing <tspan
						x="21.32" dy="1.2em" className="st6">Authority</tspan></text>		</G>
		<G id="shape1051-457" mid="1051" groupcontext="shape" layermember="8" transform="translate(481.74,-723.335)" label="Reliability Coordinator" description="Reliability coordinator (RC) ensures wide-area reliability by developing and monitoring all reliability-related parameters, performing reliability analysis, and directing necessary actions. It also directs and coordinates emergency services and system restorative operations. An RC receives facility and operational data from Generator Owners (GO), Generator Operators (GOP), Transmission Owners (TO), Transmission Operators (TOP) and Load Serving Entities (LSE) ahead of time. It receives generation dispatch information and integrated operational plans from Balancing Authorities (BA), and final decision on arranged interchange from the Interchange Coordinator (IC), all ahead of time. In the real-time it receives operational information from IC, BA and TOP. Based on its reliability analyses RC issues reliability alerts to GOP, TOP, Transmission Service Provider (TSP), BA, IC, Regional Reliability Entity and NERC in real-time. It also issues corrective actions and emergency procedure directives to TOP, BA, GOP, IC, and Distribution Provider (DP). " >
			<title>ERCOT - Reliability Coordinator</title>
			<desc>Reliability Coordinator</desc>
			
				
			
			
			
			<G id="shadow1051-458" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="19.32" y="981.9" className="st5" langid="1033">Reliability <tspan
							x="13.65" dy="1.2em" className="st6">Coordinator</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="19.32" y="981.9" className="st8" langid="1033">Reliability <tspan
						x="13.65" dy="1.2em" className="st6">Coordinator</tspan></text>		</G>
		<G id="shape1052-467" mid="1052" groupcontext="shape" layermember="8" transform="translate(724.74,-511.835)" label="Transmission Operator" description="Transmission Operator (TOP) operates the transmission facilities within its purview and ensures real-time operating reliability within its area of service. A TOP monitors the status of and deploys transmission assets (like transmission lines, protection systems) and reactive resources, adjusts flow control devices, and provides telemetry. It also develops system limitations and operates its system within the specified limits. Development and implementation of emergency procedures as well as system restoration plans are also performed by TOP." >
			<title>ERCOT - Transmission Operator</title>
			<desc>Transmission Operator</desc>
			
				
			
			
			
			<G id="shadow1052-468" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="9.32" y="981.9" className="st5" langid="1033">Transmission <tspan
							x="21.32" dy="1.2em" className="st6">Operator</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="9.32" y="981.9" className="st8" langid="1033">Transmission <tspan
						x="21.32" dy="1.2em" className="st6">Operator</tspan></text>		</G>
		<G id="shape1053-477" mid="1053" groupcontext="shape" layermember="8" transform="translate(468,-507.335)" label="Wholesale Market Operator" description="The wholesale energy market is the entity class which plays the central role in the buying and reselling of wholesale power between the suppliers and the resellers (includes utilities, Load Serving Entities and power marketers). In the regions which have regional RTOs or ISOs, they provide open access to the transmission systems and administer the wholesale electricity markets. These organized wholesale electricity markets serve about two-thirds of the U.S. population. There are FERC rules, sometimes referred to as &quot;firewalls&quot;, designed to prevent market manipulations from operation of the transmission system. Except for ERCOT, the operations and transactions of these wholesale markets are overseen by the FERC. It should be noted that transactions may also take place based on bilateral contracts in these regions in compliance with the RTO/ISO rules." >
			<title>ERCOT - Wholesale Market Operator</title>
			<desc>Wholesale Market Operator</desc>
			
				
			
			
			
			<G id="shadow1053-478" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="16.99" y="974.7" className="st5" langid="1033">Wholesale <tspan
							x="26.66" dy="1.2em" className="st6">Market </tspan><tspan x="21.32" dy="1.2em" className="st6">Operator</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="16.99" y="974.7" className="st8" langid="1033">Wholesale <tspan
						x="26.66" dy="1.2em" className="st6">Market </tspan><tspan x="21.32" dy="1.2em" className="st6">Operator</tspan></text>		</G>
		<G id="shape1054-489" mid="1054" groupcontext="shape" layermember="8" transform="translate(463.74,-632.335)" label="ERCOT" description="For enhanced coordination of resources among electrically connected utilities, Regional Transmission Operator (RTO) or Independent System Operator (ISO) were created following FERC Orders. RTOs/ISOs are independent, membership-based, non-profit organizations that optimize the wholesale electric market, ensure fair access to the transmission system, and engage in regional transmission planning and expansion. The Electric Reliability Council of Texas (ERCOT) manages the flow of electric power to more than 25 million Texas customers and represents about 90 percent of the state's electric load. As the ISO for the region, ERCOT schedules power on an electric grid that connects more than 46,500 miles of transmission lines and 650+ generation units. It also performs financial settlement for the competitive wholesale bulk-power market and administers retail switching for 8 million premises in competitive choice areas. ERCOT is a membership-based 501(c)(4) nonprofit corporation, governed by a board of directors and subject to oversight by the Public Utility Commission of Texas and the Texas Legislature. Its members include consumers, cooperatives, generators, power marketers, retail electric providers, investor-owned electric utilities, transmission and distribution providers and municipally owned electric utilities. 
Reference:
ERCOT, &quot;About ERCOT&quot;, 2020 [Online]. Available: http://www.ercot.com/about. [Accessed: 06-Jan-2020]." >
			<title>Electric Reliability Council of Texas</title>
			<desc>ERCOT</desc>
			
			
			<rect x="0" y="988" width="152" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="51.24" y="1003.4" className="st32" langid="1033">ERCOT</text>		</G>
		<G id="shape1055-492" mid="1055" groupcontext="shape" layermember="8" transform="translate(27,-18)">
			<title></title>
			<desc>1. ERCOT fulfills other NERC functions not indicated in this ...</desc>
			
			
			<rect x="0" y="920.356" width="936" height="87.6443" className="st27" style={{fill: 'inherit'}} />
			<text x="4" y="931.78" className="st28" langid="1033">1. ERCOT fulfills other NERC functions not indicated in this diagram<tspan
						x="4" dy="1.2em" className="st6">2</tspan>. Potomac Economics serves as the current Independent Market Monitor for ERCOT.<tspan
						x="4" dy="1.2em" className="st6">3</tspan>. The dotted lines connecting entities in the retail layer show the relations in the presence of an aggregator.<tspan
						x="4" dy="1.2em" className="st6">4</tspan>. TSP approves or denies transmission service requests from purchasing-selling entities, generator owners and load-serving entities (not shown in diagram)<tspan
						x="4" dy="1.2em" className="st6">5</tspan>. All market participants are monitored by Potomac Economics, and they have to be notified any changes in ownership and structure (not shown in diagram)<tspan
						x="4" dy="1.2em" className="st6">6</tspan>. Wholesale storage load is part of the merchant generators.</text>		</G>
		<G id="shape1056-500" mid="1056" groupcontext="shape" layermember="1" transform="translate(93,-669.898)">
			<title></title>
			<path d="M0 1008 L0 1068.06 L138 1068.06 A3 3 0 0 1 144 1068.06 L145.74 1068.06 A3 3 0 0 1 151.74 1068.06 L168 1068.06
						 L168 1087.31 L195 1087.31" className="st30"/>
		</G>
		<G id="shape1057-507" mid="1057" groupcontext="shape" layermember="1" transform="translate(144,-573.835)">
			<title></title>
			<desc>sets policy for &#62;</desc>
			
			
			<rect x="0" y="988" width="90" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="6.84" y="1001.6" className="st33" langid="1033">sets policy for &#62;</text>		</G>
		<G id="shape1058-510" mid="1058" groupcontext="shape" layermember="1" transform="translate(109,-600.835)">
			<title></title>
			<desc>&#60; approval and oversight</desc>
			
			
			<rect x="0" y="988" width="115.469" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="21.46" y="994.4" className="st33" langid="1033">&#60; approval and <tspan
						x="35.07" dy="1.2em" className="st6">oversight</tspan></text>		</G>
		<G id="shape1059-514" mid="1059" groupcontext="shape" layermember="1" transform="translate(288,-568.085)">
			<title></title>
			<path d="M0 1008 L-27 1008 L-27 1032.45 L-43.26 1032.45 A3 3 -180 0 0 -49.26 1032.45 L-51 1032.45 A3 3 -180 0 0 -57 1032.45
						 L-162 1032.45 L-162 1082.25" className="st34"/>
		</G>
		<G id="shape1060-522" mid="1060" groupcontext="shape" layermember="1" transform="translate(82,-527.835)">
			<title></title>
			<desc>&#60; regulates</desc>
			
			
			<rect x="0" y="988" width="152" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="49.01" y="1001.6" className="st33" langid="1033">&#60; regulates  </text>		</G>
		<G id="shape1063-525" mid="1063" groupcontext="shape" layermember="1" transform="translate(303,-556.835)">
			<title></title>
			<path d="M0 1008 L-0 1030.5 L-58.26 1030.5 A3 3 -180 0 0 -64.26 1030.5 L-66 1030.5 A3 3 -180 1 0 -72 1030.5 L-91.26 1030.5
						 L-91.26 1206" className="st34"/>
		</G>
		<G id="shape1065-532" mid="1065" groupcontext="shape" layermember="1" transform="translate(363,-601.835)">
			<title></title>
			<path d="M0 1008 L-0 744.75 L76.13 744.75 A3 3 0 1 1 82.12 744.75 L111 744.75 L111 711" className="st34"/>
		</G>
		<G id="shape1066-539" mid="1066" groupcontext="shape" layermember="1" transform="translate(378,-579.335)">
			<title></title>
			<path d="M0 1008 L3 1008 A3 3 0 1 1 9 1008 L54 1008 L54 780.14 L61.12 780.14 A3 3 0 0 1 67.13 780.14 L195 780.14 A3 3
						 0 0 1 201 780.14 L226.74 780.14 L226.74 679.5" className="st34"/>
		</G>
		<G id="shape1067-546" mid="1067" groupcontext="shape" layermember="1" transform="translate(302.625,-717.835)">
			<title></title>
			<desc>regulates operation &#62;</desc>
			
			
			<rect x="0" y="988" width="132.75" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1050.32" y="69.98" transform="rotate(-90)" className="st33" langid="1033">regulates operation &#62;</text>		</G>
		<G id="shape1068-549" mid="1068" groupcontext="shape" layermember="1" transform="translate(342,-709.835)">
			<title></title>
			<desc>licenses &#38; inspects &#62;</desc>
			
			
			<rect x="0" y="977.816" width="162" height="30.1838" className="st27" style={{fill: 'inherit'}} />
			<text x="-1043.07" y="84.6" transform="rotate(-90)" className="st33" langid="1033">licenses &#38; inspects &#62;</text>		</G>
		<G id="shape1077-552" mid="1077" groupcontext="shape" layermember="6" transform="translate(93,-723.335)">
			<title></title>
			<path d="M0 1016.44 L0 978.64 L198 978.64 L198 1017.56" className="st35"/>
		</G>
		<G id="shape1078-561" mid="1078" groupcontext="shape" layermember="6" transform="translate(109,-732.335)">
			<title></title>
			<desc>delegates development &#38; enforcement of standards &#62;</desc>
			
			
			<rect x="0" y="963" width="152" height="45" className="st27" style={{fill: 'inherit'}} />
			<text x="13.19" y="981.9" className="st37" langid="1033">delegates development &#38; <tspan
						x="8.26" dy="1.2em" className="st6">enforcement of standards </tspan>&#62;</text>		</G>
		<G id="shape1079-565" mid="1079" groupcontext="shape" layermember="6" transform="translate(78,-714.898)">
			<title></title>
			<path d="M0 1008 L0 938.81 L204 938.81 A3 3 0 0 1 210 938.81 L225 938.81 A3 3 0 1 1 231 938.81 L282 938.81 A3 3 0 0 1
						 288 938.81 L303 938.81 A3 3 0 0 1 309 938.81 L351 938.81 A3 3 0 1 1 357 938.81 L361.12 938.81 A3 3 0 1 1
						 367.12 938.81 L385.74 938.81" className="st35"/>
		</G>
		<G id="shape1080-572" mid="1080" groupcontext="shape" layermember="6" transform="translate(91,-783.326)">
			<title></title>
			<desc>oversight on compliance &#62;</desc>
			
			
			<rect x="0" y="988" width="152" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="12.02" y="1001.6" className="st37" langid="1033">oversight on compliance &#62;</text>		</G>
		<G id="shape1083-575" mid="1083" groupcontext="shape" layermember="6" transform="translate(153,-681.148)">
			<title></title>
			<path d="M0 1008 L81 1008 L81 1231.31 L85.74 1231.31 A3 3 0 0 1 91.74 1231.31 L192 1231.31 A3 3 0 0 1 198 1231.31 L228
						 1231.31 A3 3 0 0 1 234 1231.31 L258.75 1231.31 L258.75 1303.31 L291.75 1303.31 A3 3 0 0 1 297.75 1303.31
						 L375 1303.31 A3 3 0 0 1 381 1303.31 L452.37 1303.31" className="st38"/>
		</G>
		<G id="shape1085-583" mid="1085" groupcontext="shape" layermember="2" transform="translate(171,-822.335)">
			<title></title>
			<path d="M0 999 L99 999" className="st39"/>
		</G>
		<G id="shape1086-592" mid="1086" groupcontext="shape" layermember="2" transform="translate(171,-835.835)">
			<title></title>
			<desc>enacts policy through &#62;</desc>
			
			
			<rect x="0" y="988" width="99" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="17.91" y="994.4" className="st41" langid="1033">enacts policy <tspan
						x="25.61" dy="1.2em" className="st6">through </tspan>&#62;</text>		</G>
		<G id="shape1087-596" mid="1087" groupcontext="shape" layermember="2" transform="translate(319.5,-808.835)">
			<title></title>
			<path d="M-4.5 1008 L-4.5 1019.39 L-13.5 1019.39 L-13.5 1103.06" className="st39"/>
		</G>
		<G id="shape1088-603" mid="1088" groupcontext="shape" layermember="2" transform="translate(270,-736.835)">
			<title></title>
			<desc>&#60; delegates reliability monitoring to</desc>
			
			
			<rect x="0" y="963" width="90" height="45" className="st27" style={{fill: 'inherit'}} />
			<text x="-1013.38" y="34.2" transform="rotate(-90)" className="st41" langid="1033">&#60; delegates <tspan
						x="-1008.21" dy="1.2em" className="st6">reliability </tspan><tspan x="-1019.14" dy="1.2em" className="st6">monitoring to</tspan></text>		</G>
		<G id="shape1089-608" mid="1089" groupcontext="shape" layermember="2" transform="translate(360,-842.585)">
			<title></title>
			<path d="M0 1008 L79.12 1008 A3 3 0 0 1 85.13 1008 L216 1008 L216 1063.12" className="st39"/>
		</G>
		<G id="shape1090-615" mid="1090" groupcontext="shape" layermember="2" transform="translate(369,-822.708)">
			<title></title>
			<desc>oversees and regulates &#62;</desc>
			
			
			<rect x="0" y="981.745" width="132.75" height="26.2546" className="st27" style={{fill: 'inherit'}} />
			<text x="5.88" y="998.47" className="st41" langid="1033">oversees and regulates &#62;</text>		</G>
		<G id="shape1091-618" mid="1091" groupcontext="shape" layermember="5" transform="translate(277.5,-808.835)">
			<title></title>
			<path d="M7.5 1008 L7.5 1043.25 L-196.5 1043.25 A3 3 -180 0 0 -202.5 1043.25 L-228.5 1043.25 A3 3 -180 0 0 -234.5 1043.25
						 L-241.5 1043.25 L-241.5 1401.75 L-228.14 1401.75 A3 3 0 0 1 -222.14 1401.75 L-68.76 1401.75 A3 3 0 0 1 -62.76
						 1401.75 L-38.76 1401.75 A3 3 0 0 1 -32.76 1401.75 L10.5 1401.75" className="st42"/>
		</G>
		<G id="shape1092-627" mid="1092" groupcontext="shape" layermember="5" transform="translate(64.25,-385.835)">
			<title></title>
			<desc>&#60; reports on competitive performance &#38; operational efficiency</desc>
			
			
			<rect x="0" y="963" width="132.75" height="45" className="st27" style={{fill: 'inherit'}} />
			<text x="6.06" y="974.7" className="st44" langid="1033">&#60; reports on competitive <tspan
						x="29.27" dy="1.2em" className="st6">performance </tspan>&#38; <tspan x="13.47" dy="1.2em" className="st6">operational efficiency</tspan></text>		</G>
		<G id="shape1093-632" mid="1093" groupcontext="shape" layermember="5" transform="translate(348,-448.835)">
			<title></title>
			<path d="M0 1008 L-0 972.94 L33 972.94 A3 3 0 0 1 39 972.94 L90 972.94 A3 3 0 1 1 96 972.94 L96.75 972.94 A3 3 0 1 1
						 102.75 972.94 L135 972.94 L135 949.5" className="st42"/>
		</G>
		<G id="shape1094-639" mid="1094" groupcontext="shape" layermember="5" transform="translate(315,-464.693)">
			<title></title>
			<desc>monitors market participants &#38; rules &#62;</desc>
			
			
			<rect x="0" y="968.699" width="132.75" height="39.301" className="st27" style={{fill: 'inherit'}} />
			<text x="25.44" y="984.75" className="st44" langid="1033">monitors market <tspan
						x="14.32" dy="1.2em" className="st6">participants </tspan>&#38; rules &#62;</text>		</G>
		<G id="shape1095-643" mid="1095" groupcontext="shape" layermember="2" transform="translate(123,-678.335)">
			<title></title>
			<path d="M0 1016.44 L0 1040.64 L108 1040.64 A3 3 0 1 1 114 1040.64 L153 1040.64 L153 1017.56" className="st39"/>
		</G>
		<G id="shape1096-650" mid="1096" groupcontext="shape" layermember="2" transform="translate(139.5,-633.906)">
			<title></title>
			<desc>&#60; provides reports on reliability to</desc>
			
			
			<rect x="0" y="977.816" width="99" height="30.1838" className="st27" style={{fill: 'inherit'}} />
			<text x="4.98" y="989.31" className="st41" langid="1033">&#60; provides reports <tspan
						x="12.58" dy="1.2em" className="st6">on reliability to</tspan></text>		</G>
		<G id="shape1097-654" mid="1097" groupcontext="shape" layermember="6" transform="translate(306,-668.773)">
			<title></title>
			<path d="M0 1008 L0 1029.94 L54 1029.94 A3 3 0 0 1 60 1029.94 L75 1029.94 A3 3 0 0 1 81 1029.94 L123 1029.94 A3 3 0 0
						 1 129 1029.94 L138.75 1029.94 A3 3 0 0 1 144.75 1029.94 L157.74 1029.94" className="st35"/>
		</G>
		<G id="shape1098-661" mid="1098" groupcontext="shape" layermember="6" transform="translate(297,-628.436)">
			<title></title>
			<desc>compliance enforcement &#62;</desc>
			
			
			<rect x="0" y="953.202" width="161" height="54.798" className="st27" style={{fill: 'inherit'}} />
			<text x="15.16" y="984.2" className="st45" langid="1033">compliance enforcement &#62;</text>		</G>
		<G id="shape1101-664" mid="1101" groupcontext="shape" layermember="6" transform="translate(631.743,-965.74)">
			<title></title>
			<path d="M0 1008 L169.8 1008 L169.8 1034.4" className="st46"/>
		</G>
		<G id="shape1102-669" mid="1102" groupcontext="shape" layermember="6" transform="translate(798.157,-965.74)">
			<title></title>
			<path d="M0 1008 L161.84 1008 L161.84 1148.18" className="st46"/>
		</G>
		<G id="shape1105-674" mid="1105" groupcontext="shape" layermember="6" transform="translate(441,-646.835)">
			<title></title>
			<path d="M0 1008 L0 1190.05 L3.75 1190.05 A3 3 0 0 1 9.75 1190.05 L179.38 1190.05 L179.38 1246.5" className="st46"/>
		</G>
		<G id="shape1106-679" mid="1106" groupcontext="shape" layermember="6" transform="translate(960,-961.835)">
			<title></title>
			<path d="M0 1008 L93 1008 L93 1502.71 L84 1502.71" className="st46"/>
		</G>
		<G id="shape1107-684" mid="1107" groupcontext="shape" layermember="6" transform="translate(504,-968.918)">
			<title></title>
			<path d="M0 1009.92 L130.74 1009.92 L130.74 1024.08" className="st46"/>
		</G>
		<G id="shape1108-689" mid="1108" groupcontext="shape" layermember="1" transform="translate(144,-493.835)">
			<title></title>
			<desc>&#60; regulates</desc>
			
			
			<rect x="0" y="988" width="152" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1024.99" y="79.6" transform="rotate(-90)" className="st33" langid="1033">&#60; regulates  </text>		</G>
		<G id="shape1111-692" mid="1111" groupcontext="shape" layermember="6" transform="translate(442.125,-646.835)">
			<title></title>
			<path d="M0 1008 L0 687.84 L61.87 687.84 L61.87 711" className="st46"/>
		</G>
		<G id="shape1112-697" mid="1112" groupcontext="shape" layermember="6" transform="translate(223.5,-464.835)">
			<title></title>
			<desc>oversight on compliance &#62;</desc>
			
			
			<rect x="0" y="988" width="109.5" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="24.42" y="994.4" className="st37" langid="1033">oversight on <tspan
						x="22.46" dy="1.2em" className="st6">compliance </tspan>&#62;</text>		</G>
		<G id="shape1115-701" mid="1115" groupcontext="shape" layermember="6" transform="translate(571.74,-757.085)">
			<title></title>
			<path d="M0 1008 L48 1008 L48 857.25" className="st38"/>
		</G>
		<G id="shape1118-708" mid="1118" groupcontext="shape" layermember="6" transform="translate(619.74,-876.557)">
			<title></title>
			<path d="M0 1008 L0 1012.72 L-12 1012.72 A3 3 -180 1 0 -18 1012.72 L-85.74 1012.72 L-85.74 985.72" className="st46"/>
		</G>
		<G id="shape1119-713" mid="1119" groupcontext="shape" layermember="6" transform="translate(619.74,-876.446)">
			<title></title>
			<path d="M0 1007.89 L0 1012.61 L97.26 1012.61 A3 3 0 1 1 103.26 1012.61 L151.8 1012.61 L151.8 990.11" className="st46"/>
		</G>
		<G id="shape1120-718" mid="1120" groupcontext="shape" layermember="6" transform="translate(554.266,-768.218)">
			<title></title>
			<desc>monitors &#38; directs &#62;</desc>
			
			
			<rect x="0" y="895.383" width="115.469" height="112.617" className="st27" style={{fill: 'inherit'}} />
			<text x="-1001.44" y="61.33" transform="rotate(-90)" className="st45" langid="1033">monitors &#38; directs &#62;</text>		</G>
		<G id="shape1121-721" mid="1121" groupcontext="shape" layermember="6" transform="translate(771.54,-884.601)">
			<title></title>
			<path d="M0 1008 L2.46 1038.77 L2.46 1078.29 L98.46 1078.29 A3 3 0 1 1 104.46 1078.29 L128.46 1078.29" className="st46"/>
		</G>
		<G id="shape1124-726" mid="1124" groupcontext="shape" layermember="6" transform="translate(855,-814.315)">
			<title></title>
			<path d="M0 1008 L9 1008 L9 1383.71 L-97.26 1383.71 A3 3 -180 0 0 -103.26 1383.71 L-123.09 1383.71 L-123.09 1425.23 L-132
						 1425.23 A3 3 -180 0 0 -138 1425.23 L-159.62 1425.23" className="st46"/>
		</G>
		<G id="shape1137-731" mid="1137" groupcontext="shape" layermember="3" transform="translate(665.375,-363.335)">
			<title></title>
			<path d="M0 1008 L0 1041.75 L180.63 1041.75" className="st47"/>
		</G>
		<G id="shape1138-740" mid="1138" groupcontext="shape" layermember="3" transform="translate(684,-322)">
			<title></title>
			<desc>operates distribution facilities &#38; provides services for &#62;</desc>
			
			
			<rect x="0" y="991.542" width="161" height="16.4584" className="st27" style={{fill: 'inherit'}} />
			<text x="7.72" y="996.17" className="st49" langid="1033">operates distribution facilities <tspan
						x="20.55" dy="1.2em" className="st6">&#38; </tspan>provides services for &#62;</text>		</G>
		<G id="shape1142-744" mid="1142" groupcontext="shape" layermember="7" transform="translate(891,-318.335)">
			<title></title>
			<path d="M0 1008 L0 1038.12 L-67.85 1038.12 A3 3 -180 0 0 -73.85 1038.12 L-115.85 1038.12 L-115.85 1072.44"
					className="st50"/>
		</G>
		<G id="shape1143-753" mid="1143" groupcontext="shape" layermember="7" transform="translate(775.154,-285.421)">
			<title></title>
			<path d="M0 1008 L-97.15 1008 L-97.15 1060.59" className="st52"/>
		</G>
		<G id="shape1144-759" mid="1144" groupcontext="shape" layermember="7" transform="translate(680.25,-268.835)">
			<title></title>
			<desc>&#60; sells retail electricity to</desc>
			
			
			<rect x="0" y="988" width="133.5" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="6.01" y="1001.6" className="st53" langid="1033">&#60; sells retail electricity to</text>		</G>
		<G id="shape1168-762" mid="1168" groupcontext="shape" layermember="3" transform="translate(680.375,-408.335)">
			<title></title>
			<path d="M0 1008 L0 971.71 L36.62 971.71 A3 3 0 0 1 42.62 971.71 L71.36 971.71 A3 3 0 0 1 77.36 971.71 L180.63 971.71
						 A3 3 0 1 1 186.63 971.71 L273.63 971.71" className="st47"/>
		</G>
		<G id="shape1169-769" mid="1169" groupcontext="shape" layermember="3" transform="translate(639.916,-477.377)">
			<title></title>
			<desc>&#60; coordinates operations &#62;</desc>
			
			
			<rect x="0" y="991.542" width="125.084" height="16.4584" className="st27" style={{fill: 'inherit'}} />
			<text x="-1032.97" y="58.94" transform="rotate(-90)" className="st49" langid="1033">&#60; coordinates <tspan
						x="-1030.43" dy="1.2em" className="st6">operations </tspan>&#62;</text>		</G>
		<G id="shape1179-773" mid="1179" groupcontext="shape" layermember="6" transform="translate(571.74,-736.835)">
			<title></title>
			<path d="M0 999 L153 999" className="st35"/>
		</G>
		<G id="shape1180-780" mid="1180" groupcontext="shape" layermember="6" transform="translate(586,-743.835)">
			<title></title>
			<desc>reliability alerts &#62;</desc>
			
			
			<rect x="0" y="988" width="152" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="33.9" y="1001.6" className="st37" langid="1033">reliability alerts &#62;</text>		</G>
		<G id="shape1181-783" mid="1181" groupcontext="shape" layermember="2" transform="translate(345,-808.835)">
			<title></title>
			<path d="M0 1008 L-0 1024 L15 1024 A3 3 0 0 1 21 1024 L39 1024 L39 1567.67 L78 1567.67" className="st54"/>
		</G>
		<G id="shape1183-791" mid="1183" groupcontext="shape" layermember="2" transform="translate(384,-288.335)">
			<title></title>
			<path d="M0 1008 L0 991.5 L144 991.5 A3 3 0 0 1 150 991.5 L180 991.5 A3 3 0 0 1 186 991.5 L262.31 991.5 A3 3 0 1 1 268.31
						 991.5 L433.15 991.5 A3 3 0 0 1 439.15 991.5 L477 991.5 L477 978" className="st55"/>
		</G>
		<G id="shape1184-796" mid="1184" groupcontext="shape" layermember="2" transform="translate(621.345,-304.835)">
			<title></title>
			<path d="M3.97 1008 L3.97 975.25 L14.03 975.25 L14.03 949.5" className="st55"/>
		</G>
		<G id="shape1185-801" mid="1185" groupcontext="shape" layermember="2" transform="translate(315,-699.835)">
			<title></title>
			<desc>&#60; regulates</desc>
			
			
			<rect x="0" y="988" width="152" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1024.99" y="79.6" transform="rotate(-90)" className="st41" langid="1033">&#60; regulates</text>		</G>
		<G id="shape1200-804" mid="1200" groupcontext="shape" layermember="4" transform="translate(754.74,-511.835)">
			<title></title>
			<path d="M0 1008 L0 1090.24 L-19.83 1090.24 A3 3 -180 0 0 -25.83 1090.24 L-31.74 1090.24 A3 3 -180 0 0 -37.74 1090.24
						 L-71.36 1090.24 A3 3 -180 0 0 -77.36 1090.24 L-104.36 1090.24 L-104.36 1111.5" className="st56"/>
		</G>
		<G id="shape1201-813" mid="1201" groupcontext="shape" layermember="4" transform="translate(984,-433.377)">
			<title></title>
			<path d="M0 1008 L0 1021.5 L-249.09 1021.5 A3 3 -180 0 0 -255.09 1021.5 L-261 1021.5 A3 3 -180 1 0 -267 1021.5 L-300.63
						 1021.5 A3 3 -180 0 0 -306.62 1021.5 L-318.62 1021.5 L-318.62 1033.04" className="st58"/>
		</G>
		<G id="shape1202-821" mid="1202" groupcontext="shape" layermember="4" transform="translate(769.5,-421)">
			<title></title>
			<desc>&#60; deliver power to</desc>
			
			
			<rect x="0" y="993.625" width="207" height="14.375" className="st27" style={{fill: 'inherit'}} />
			<text x="58.91" y="1004.41" className="st59" langid="1033">&#60; deliver power to</text>		</G>
		<G id="shape1203-824" mid="1203" groupcontext="shape" layermember="6" transform="translate(63,-692.398)">
			<title></title>
			<path d="M0 1008 L-10.64 1008 L-10.64 1364.06 L103.74 1364.06" className="st38"/>
		</G>
		<G id="shape1204-831" mid="1204" groupcontext="shape" layermember="6" transform="translate(45,-345.335)">
			<title></title>
			<desc>oversight on compliance &#62;</desc>
			
			
			<rect x="0" y="985.5" width="115.469" height="22.5" className="st27" style={{fill: 'inherit'}} />
			<text x="27.4" y="993.15" className="st37" langid="1033">oversight on <tspan
						x="25.44" dy="1.2em" className="st6">compliance </tspan>&#62;</text>		</G>
		<G id="shape1205-835" mid="1205" groupcontext="shape" layermember="4" transform="translate(814.74,-523.085)">
			<title></title>
			<path d="M0 1008 L19.26 1008 A3 3 0 0 1 25.26 1008 L46.26 1008 A3 3 0 1 1 52.26 1008 L184.26 1008 L184.26 1052.71"
					className="st56"/>
		</G>
		<G id="shape1206-842" mid="1206" groupcontext="shape" layermember="4" transform="translate(823.5,-504.085)">
			<title></title>
			<desc>&#60; interchange power &#62;</desc>
			
			
			<rect x="0" y="988" width="207" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="48.63" y="1001.6" className="st59" langid="1033">&#60; interchange power &#62;</text>		</G>
		<G id="shape1207-845" mid="1207" groupcontext="shape" layermember="0" transform="translate(1179,-399.335)">
			<title></title>
		</G>
		<G id="shape1215-846" mid="1215" groupcontext="shape" layermember="2" transform="translate(360,-820.085)">
			<title></title>
			<path d="M0 1008 L79.12 1008 A3 3 0 0 1 85.13 1008 L213 1008 A3 3 0 0 1 219 1008 L241.74 1008 A3 3 0 1 1 247.74 1008
						 L256.74 1008 A3 3 0 1 1 262.74 1008 L411 1008 A3 3 0 1 1 417 1008 L513 1008 L513 1244.25 L558 1244.25 A3
						 3 0 1 1 564 1244.25 L588 1244.25 A3 3 0 1 1 594 1244.25 L669 1244.25 L669 1349.71" className="st54"/>
		</G>
		<G id="shape1216-853" mid="1216" groupcontext="shape" layermember="2" transform="translate(600.271,-799.31)">
			<title></title>
			<desc>regulates &#62;</desc>
			
			
			<rect x="0" y="981.745" width="232.469" height="26.2546" className="st27" style={{fill: 'inherit'}} />
			<text x="89.24" y="998.47" className="st41" langid="1033">regulates &#62;</text>		</G>
		<G id="shape1217-856" mid="1217" groupcontext="shape" layermember="4" transform="translate(241.74,-358.835)">
			<title></title>
			<path d="M0 1008 L-0 747 L118.26 747 A3 3 0 0 1 124.26 747 L139.26 747 A3 3 0 0 1 145.26 747 L187.26 747 A3 3 0 0 1 193.26
						 747 L196.26 747 A3 3 0 0 1 202.26 747 L203.01 747 A3 3 0 0 1 209.01 747 L238.26 747 A3 3 0 0 1 244.26 747
						 L341.62 747 L341.62 632.25 L483 632.25" className="st60"/>
		</G>
		<G id="shape1220-864" mid="1220" groupcontext="shape" layermember="4" transform="translate(486,-595.572)">
			<title></title>
			<desc>&#60; DC interchange services</desc>
			
			
			<rect x="0" y="988" width="99" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="7.77" y="994.4" className="st59" langid="1033">&#60; DC interchange <tspan
						x="30.12" dy="1.2em" className="st6">services</tspan></text>		</G>
		<G id="shape1221-868" mid="1221" groupcontext="shape" layermember="3" transform="translate(769.74,-511.835)">
			<title></title>
			<desc>&#60;coordinate power exchange&#62;</desc>
			
			
			<path d="M0 1008 L0 1063.96 L91.26 1063.96 A3 3 0 1 1 97.26 1063.96 L184.26 1063.96" className="st61"/>
			<rect rectcontext="textBkgnd" x="11.2705" y="1045.8" width="147.98" height="14.4001" className="st62" style={{fill: 'inherit'}} />
			<text x="11.27" y="1056.6" className="st49" langid="1033">&#60;coordinate power exchange&#62;</text>		</G>
		<G id="shape1226-878" mid="1226" groupcontext="shape" layermember="8" transform="translate(891,-708.565)" label="Resource Entity" description="An entity class that owns or controls an all-inclusive resource and is registered with ERCOT as a Resource Entity. The term 'resource' is used to refer to both a generation resource and a load resource. 
Reference:
ERCOT, &quot;Resource Entities&quot;, 2020 [Online]. Available: http://www.ercot.com/services/rq/re. [Accessed: 06-Jan-2020]." >
			<title>Resource Entity</title>
			<desc>Resource Entity</desc>
			
				
			
			
			
			<G id="shadow1226-879" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="19.32" y="981.9" className="st5" langid="1033">Resource <tspan
							x="29.99" dy="1.2em" className="st6">Entity</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="19.32" y="981.9" className="st8" langid="1033">Resource <tspan
						x="29.99" dy="1.2em" className="st6">Entity</tspan></text>		</G>
		<G id="shape1227-888" mid="1227" groupcontext="shape" layermember="8" transform="translate(603.24,-534.335)" label="Retail Market" description="Coordinates retail market transaction including Transmission/Distribution Service Provider (TDSP) Electronic Service Identifier (ESI ID) reports, monthly meter reading transactions by TDSPs, customer move-ins, customer switches, and the labeling of electricity forms between wire companies, retailer, and metering entities." >
			<title>ERCOT - Retail Market Operator</title>
			<desc>Retail Market</desc>
			
				
			
			
			
			<G id="shadow1227-889" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="9.66" y="989.1" className="st5" langid="1033">Retail Market</text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="9.66" y="989.1" className="st8" langid="1033">Retail Market</text>		</G>
		<G id="shape1229-896" mid="1229" groupcontext="shape" layermember="7" transform="translate(663.24,-534.335)">
			<title></title>
			<path d="M0 1008 L0 1092.34 L35.76 1092.34 A3 3 0 0 1 41.76 1092.34 L56.76 1092.34 L56.76 1190.25 L182.76 1190.25"
					className="st63"/>
		</G>
		<G id="shape1230-903" mid="1230" groupcontext="shape" layermember="7" transform="translate(720,-341.533)">
			<title></title>
			<desc>provides customer switch information &#62;</desc>
			
			
			<rect x="0" y="986.197" width="109.5" height="21.8026" className="st27" style={{fill: 'inherit'}} />
			<text x="9.33" y="993.5" className="st53" langid="1033">provides customer <tspan
						x="4.35" dy="1.2em" className="st6">switch information </tspan>&#62;</text>		</G>
		<G id="shape1231-907" mid="1231" groupcontext="shape" layermember="7" transform="translate(643.307,-408.335)">
			<title></title>
			<path d="M-7.93 1008 L-10.07 882" className="st64"/>
		</G>
		<G id="shape1232-916" mid="1232" groupcontext="shape" layermember="7" transform="translate(570.062,-458.732)">
			<title></title>
			<desc>meter reads &#38; customer connection &#62;</desc>
			
			
			<rect x="0" y="975.5" width="122.938" height="32.5" className="st27" style={{fill: 'inherit'}} />
			<text x="-1026.87" y="57.87" transform="rotate(-90)" className="st53" langid="1033">meter reads &#38; <tspan
						x="-1047.76" dy="1.2em" className="st6">customer connection </tspan>&#62;</text>		</G>
		<G id="shape1233-920" mid="1233" groupcontext="shape" layermember="8" transform="translate(918,-202.5)" label="Opt In Entity" description="A Municipally Owned Utility (MOU) or an Electric Cooperative (EC) that opts to offer Customer Choice. 
Reference:
ERCOT, &quot;Load Serving Entities&quot;, 2020 [Online]. Available: http://www.ercot.com/services/rq/lse. [Accessed: 06-Jan-2020]." >
			<title>Opt In Entity</title>
			<desc>Opt In Entity</desc>
			
				
			
			
			
			<G id="shadow1233-921" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="11.98" y="989.1" className="st5" langid="1033">Opt In Entity</text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="11.98" y="989.1" className="st8" langid="1033">Opt In Entity</text>		</G>
		<G id="shape1234-928" mid="1234" groupcontext="shape" layermember="7" transform="translate(936,-340.835)">
			<title></title>
			<path d="M0 1008 L42 1008 L42 1101.34" className="st64"/>
		</G>
		<G id="shape1235-935" mid="1235" groupcontext="shape" layermember="7" transform="translate(929.016,-283.5)">
			<title></title>
			<desc>serves customers via &#62;</desc>
			
			
			<rect x="0" y="980.533" width="94.9688" height="27.4672" className="st27" style={{fill: 'inherit'}} />
			<text x="-1036.52" y="43.88" transform="rotate(-90)" className="st53" langid="1033">serves customers <tspan
						x="-1005.57" dy="1.2em" className="st6">via </tspan>&#62;</text>		</G>
		<G id="shape1236-939" mid="1236" groupcontext="shape" layermember="3" transform="translate(605.375,-397.085)">
			<title></title>
			<path d="M0 1008 L-74.37 1008 L-74.37 1290.84 L506.87 1290.84 L506.87 1212.75" className="st65"/>
		</G>
		<G id="shape1237-947" mid="1237" groupcontext="shape" layermember="3" transform="translate(893.25,-105.25)">
			<title></title>
			<desc>owns &#38; operates &#62;</desc>
			
			
			<rect x="0" y="975.5" width="132.75" height="32.5" className="st27" style={{fill: 'inherit'}} />
			<text x="20.66" y="995.35" className="st49" langid="1033">owns &#38; operates &#62;</text>		</G>
		<G id="shape1238-950" mid="1238" groupcontext="shape" layermember="8" transform="translate(1082.25,-192.335)" label="Non Opt In Entity" description="A Municipally Owned Utility (MOU) or an Electric Cooperative (EC) that does not offer Customer Choice. 
Reference:
ERCOT, &quot;Load Serving Entities&quot;, 2020 [Online]. Available: http://www.ercot.com/services/rq/lse. [Accessed: 06-Jan-2020]." >
			<title>Non Opt In Entity</title>
			<desc>Non Opt In Entity</desc>
			
				
			
			
			
			<G id="shadow1238-951" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="15.98" y="981.9" className="st5" langid="1033">Non Opt In <tspan
							x="29.99" dy="1.2em" className="st6">Entity</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="15.98" y="981.9" className="st8" langid="1033">Non Opt In <tspan
						x="29.99" dy="1.2em" className="st6">Entity</tspan></text>		</G>
		<G id="shape1242-960" mid="1242" groupcontext="shape" layermember="8" transform="translate(891,-601.835)" label="Qualified Scheduling Entity" description="Entity class that is qualified by ERCOT for communication with ERCOT for Resource Entities and Load Serving Entities, and for settling payments and charges with ERCOT. 
Reference:
ERCOT, &quot;Qualified Scheduling Entities&quot;, 2020 [Online]. Available: http://www.ercot.com/services/rq/lse. [Accessed: 06-Jan-2020]." >
			<title>Qualified Scheduling Entity</title>
			<desc>Qualified Scheduling Entity</desc>
			
				
			
			
			
			<G id="shadow1242-961" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="21.32" y="974.7" className="st5" langid="1033">Qualified <tspan
							x="15.31" dy="1.2em" className="st6">Scheduling </tspan><tspan x="29.99" dy="1.2em" className="st6">Entity</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="21.32" y="974.7" className="st8" langid="1033">Qualified <tspan
						x="15.31" dy="1.2em" className="st6">Scheduling </tspan><tspan x="29.99" dy="1.2em" className="st6">Entity</tspan></text>		</G>
		<G id="shape1243-972" mid="1243" groupcontext="shape" layermember="3" transform="translate(740.37,-444.627)">
			<title></title>
			<path d="M-2.37 1008 L-17.37 1008 A3 3 -180 1 0 -23.37 1008 L-38.37 1008 L-38.37 918.29 L-15.63 918.29" className="st66"/>
		</G>
		<G id="shape1244-977" mid="1244" groupcontext="shape" layermember="3" transform="translate(760.74,-723.335)">
			<title></title>
			<path d="M9 1008 L9 1174.5" className="st65"/>
		</G>
		<G id="shape1245-984" mid="1245" groupcontext="shape" layermember="3" transform="translate(769.74,-574.835)">
			<title></title>
			<path d="M0 1008 L64.26 1008 A3 3 0 1 1 70.26 1008 L91.26 1008 A3 3 0 1 1 97.26 1008 L148.26 1008 A3 3 0 1 1 154.26 1008
						 L178.26 1008 A3 3 0 1 1 184.26 1008 L244.26 1008 L244.26 1104.46" className="st67"/>
		</G>
		<G id="shape1246-989" mid="1246" groupcontext="shape" layermember="3" transform="translate(729,-655.835)">
			<title></title>
			<desc>&#60; coordinate transfer capabilities</desc>
			
			
			<rect x="0" y="988" width="115.469" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1049.59" y="54.13" transform="rotate(-90)" className="st49" langid="1033">&#60; coordinate transfer <tspan
						x="-1025.44" dy="1.2em" className="st6">capabilities</tspan></text>		</G>
		<G id="shape1247-993" mid="1247" groupcontext="shape" layermember="4" transform="translate(716.4,-458.377)">
			<title></title>
			<desc>&#60; deliver power to</desc>
			
			
			<rect x="0" y="988" width="72" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1019.02" y="32.4" transform="rotate(-90)" className="st59" langid="1033">&#60; deliver <tspan
						x="-1020.21" dy="1.2em" className="st6">power to</tspan></text>		</G>
		<G id="shape1248-997" mid="1248" groupcontext="shape" layermember="4" transform="translate(981,-731.065)">
			<title></title>
			<path d="M0 1008 L69 1008 A3 3 0 0 1 75 1008 L81 1008 L81 1283.19 L63 1283.19" className="st58"/>
		</G>
		<G id="shape1249-1004" mid="1249" groupcontext="shape" layermember="4" transform="translate(1062,-596.229)">
			<title></title>
			<path d="M0 1008 L0 1069.89 L-6 1069.89 A3 3 -180 0 0 -12 1069.89 L-30 1069.89 A3 3 -180 0 0 -36 1069.89 L-45 1069.89
						 A3 3 -180 0 0 -51 1069.89 L-195 1069.89 A3 3 -180 1 0 -201 1069.89 L-222 1069.89 A3 3 -180 0 0 -228 1069.89
						 L-247.26 1069.89" className="st68"/>
		</G>
		<G id="shape1250-1009" mid="1250" groupcontext="shape" layermember="4" transform="translate(1008,-671.835)">
			<title></title>
			<desc>&#60; provide bulk power services to</desc>
			
			
			<rect x="0" y="988" width="144" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1049.78" y="68.4" transform="rotate(-90)" className="st59" langid="1033">&#60; provide bulk power <tspan
						x="-1023.91" dy="1.2em" className="st6">services to</tspan></text>		</G>
		<G id="shape1251-1013" mid="1251" groupcontext="shape" layermember="3" transform="translate(972,-719.815)">
			<title></title>
			<path d="M9 1008 L54 1008 L54 1103.48 L9 1103.48" className="st69"/>
		</G>
		<G id="shape1252-1020" mid="1252" groupcontext="shape" layermember="3" transform="translate(963,-662.835)">
			<title></title>
			<desc>&#60; balancing &#38; control</desc>
			
			
			<rect x="0" y="988" width="144" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1049.97" y="75.6" transform="rotate(-90)" className="st49" langid="1033">&#60; balancing &#38; control</text>		</G>
		<G id="shape1253-1023" mid="1253" groupcontext="shape" layermember="3" transform="translate(647.94,-625.46)">
			<title></title>
			<path d="M0 1013.62 L0 1030.81 L118.8 1030.81 A3 3 0 0 1 124.8 1030.81 L162.06 1030.81 L162.06 1020.37 L213.06 1020.37
						 A3 3 0 0 1 219.06 1020.37 L222.06 1020.37 A3 3 0 0 1 228.06 1020.37 L243.06 1020.37" className="st61"/>
		</G>
		<G id="shape1254-1030" mid="1254" groupcontext="shape" layermember="3" transform="translate(801,-601.835)">
			<title></title>
			<desc>balancing &#38; control &#62;</desc>
			
			
			<rect x="0" y="988" width="90" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="16.23" y="994.4" className="st49" langid="1033">balancing &#38; <tspan
						x="23.16" dy="1.2em" className="st6">control </tspan>&#62;</text>		</G>
		<G id="shape1255-1034" mid="1255" groupcontext="shape" layermember="3" transform="translate(754.74,-556.835)">
			<title></title>
			<path d="M0 1008 L0 970.36 L-121.8 970.36 L-121.8 945" className="st65"/>
		</G>
		<G id="shape1256-1041" mid="1256" groupcontext="shape" layermember="3" transform="translate(603.24,-574.835)">
			<title></title>
			<desc>&#60; directs system restoration</desc>
			
			
			<rect x="0" y="977.816" width="161" height="30.1838" className="st27" style={{fill: 'inherit'}} />
			<text x="12.48" y="996.51" className="st49" langid="1033">&#60; directs system restoration</text>		</G>
		<G id="shape1259-1044" mid="1259" groupcontext="shape" layermember="3" transform="translate(754.74,-592.835)">
			<title></title>
			<path d="M0 1008 L12 1008 A3 3 0 1 1 18 1008 L82.26 1008 L82.26 1108.38 L106.26 1108.38 A3 3 0 1 1 112.26 1108.38 L214.26
						 1108.38 L214.26 1122.46" className="st67"/>
		</G>
		<G id="shape1260-1049" mid="1260" groupcontext="shape" layermember="4" transform="translate(241.74,-313.835)">
			<title></title>
			<path d="M0 1008 L-0 1023.75 L127.26 1023.75 L127.26 1053 L139.26 1053 A3 3 0 0 1 145.26 1053 L193.26 1053 A3 3 0 0 1
						 199.26 1053 L286.26 1053 A3 3 0 0 1 292.26 1053 L322.26 1053 A3 3 0 0 1 328.26 1053 L403.92 1053 A3 3 0
						 0 1 409.92 1053 L433.26 1053 A3 3 0 0 1 439.26 1053 L530.41 1053 A3 3 0 0 1 536.41 1053 L575.41 1053 A3
						 3 0 0 1 581.41 1053 L661.26 1053 A3 3 0 0 1 667.26 1053 L733.26 1053 A3 3 0 1 1 739.26 1053 L757.26 1053
						 L757.26 888.46" className="st70"/>
		</G>
		<G id="shape1261-1056" mid="1261" groupcontext="shape" layermember="4" transform="translate(205.5,-295.835)">
			<title></title>
			<desc>is a type of &#62;</desc>
			
			
			<rect x="0" y="988" width="207" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="72.63" y="1001.6" className="st59" langid="1033">is a type of &#62;</text>		</G>
		<G id="shape1262-1059" mid="1262" groupcontext="shape" layermember="3" transform="translate(602.94,-653.585)">
			<title></title>
			<path d="M0 1008 L-16.58 1008 A3 3 -180 0 0 -22.58 1008 L-116.94 1008 A3 3 -180 0 0 -122.94 1008 L-155.19 1008 L-155.19
						 1314 L-215.94 1314 A3 3 -180 0 0 -221.94 1314 L-346.2 1314" className="st61"/>
		</G>
		<G id="shape1263-1066" mid="1263" groupcontext="shape" layermember="3" transform="translate(253,-347.835)">
			<title></title>
			<desc>&#60; coordinates interchange</desc>
			
			
			<rect x="0" y="988" width="152" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="13.66" y="1001.6" className="st49" langid="1033">&#60; coordinates interchange</text>		</G>
		<G id="shape1264-1069" mid="1264" groupcontext="shape" layermember="3" transform="translate(549,-910.085)">
			<title></title>
			<path d="M11.7 1008 L12.06 1008 L31.74 1008 L31.74 1037.25 L52.74 1037.25 A3 3 0 0 1 58.74 1037.25 L67.74 1037.25 A3
						 3 0 1 1 73.74 1037.25 L171 1037.25 L171 1065.25 L408 1065.25 A3 3 0 0 1 414 1065.25 L458 1065.25 L458 1147.25
						 L417 1147.25 L417 1164.52" className="st71"/>
		</G>
		<G id="shape1265-1077" mid="1265" groupcontext="shape" layermember="3" transform="translate(654.495,-880.835)">
			<title></title>
			<path d="M7.75 1008 L7.75 994.5 L10.25 994.5 L10.25 993.06" className="st72"/>
		</G>
		<G id="shape1266-1083" mid="1266" groupcontext="shape" layermember="3" transform="translate(817.363,-852.835)">
			<title></title>
			<path d="M-2.18 1008 L-2.18 994.5 L-15.82 994.5 L-15.82 978.56" className="st72"/>
		</G>
		<G id="shape1267-1088" mid="1267" groupcontext="shape" layermember="3" transform="translate(1007.5,-803.481)">
			<title></title>
			<path d="M-0.5 1000.83 L-5.71 999.71" className="st72"/>
		</G>
		<G id="shape1268-1093" mid="1268" groupcontext="shape" layermember="3" transform="translate(954,-793.065)">
			<title></title>
			<desc>owns or controls &#62;</desc>
			
			
			<rect x="0" y="988" width="122.938" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1043.11" y="65.07" transform="rotate(-90)" className="st49" langid="1033">owns or controls &#62;</text>		</G>
		<G id="shape1269-1096" mid="1269" groupcontext="shape" layermember="5" transform="translate(81,-482.585)">
			<title></title>
			<desc>1m&#62; markets wholesale electric power produced by 1m&#62;</desc>
			
			
			<path d="M0 1008 L-25.64 1008 A3 3 -180 0 0 -31.64 1008 L-35 1008 L-35 569.25 L231 569.25 A3 3 0 0 1 237 569.25 L358.12
						 569.25 A3 3 0 0 1 364.12 569.25 L378 569.25" className="st73"/>
			<rect rectcontext="textBkgnd" x="-22.2107" y="535.686" width="188.421" height="28.8001" className="st62" style={{fill: 'inherit'}} />
			<text x="-22.21" y="546.49" className="st44" langid="1033">1m&#62; markets wholesale electric power <tspan
						x="29.21" dy="1.2em" className="st6">produced by </tspan>1m&#62;</text>		</G>
		<G id="shape1270-1108" mid="1270" groupcontext="shape" layermember="7" transform="translate(1082.25,-195.71)">
			<title></title>
			<path d="M0 1000.12 L-13.5 1000.12 L-13.5 1021.37 L-65.25 1021.37 A3 3 -180 0 0 -71.25 1021.37 L-215.25 1021.37 A3 3
						 -180 0 0 -221.25 1021.37 L-224.25 1021.37 A3 3 -180 0 0 -230.25 1021.37 L-277.1 1021.37 L-277.1 1009.93"
					className="st50"/>
		</G>
		<G id="shape1271-1115" mid="1271" groupcontext="shape" layermember="7" transform="translate(808.312,-180.585)">
			<title></title>
			<path d="M0 1006.25 L-91.05 1006.25 A3 3 -180 0 0 -97.05 1006.25 L-145.31 1006.25 L-145.31 991.75" className="st52"/>
		</G>
		<G id="shape1272-1120" mid="1272" groupcontext="shape" layermember="7" transform="translate(855,-179)">
			<title></title>
			<desc>&#60; sells and distributes retail electricity to</desc>
			
			
			<rect x="0" y="988" width="225" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="13.87" y="1001.6" className="st53" langid="1033">&#60; sells and distributes retail electricity to</text>		</G>
		<G id="shape1273-1123" mid="1273" groupcontext="shape" layermember="8" transform="translate(1062,-394.835)" label="Load Serving Entity" description="Load Serving Entity (LSE) is an entity class which provides energy services to the end-use customers (both individual and wholesale customers), but it may or may not serve as a distribution provider (which provides the &quot;wires&quot; services). In ERCOT region, LSEs include Competitive Retailers (CRs) and Non-Opt-In Entities (NOIEs). CRs are Munis or Co-ops which opt to offer customer choice (i.e. allows customer to choose Retail Electric Provider), while NOIEs are Munis or Co-ops which do not offer customer choice. 
Reference:
ERCOT, &quot;Load Serving Entities&quot;, 2020 [Online]. Available: http://www.ercot.com/services/rq/lse. [Accessed: 06-Jan-2020]." >
			<title>Load Serving Entity</title>
			<desc>Load Serving Entity</desc>
			
				
			
			
			
			<G id="shadow1273-1124" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="9.64" y="981.9" className="st5" langid="1033">Load Serving <tspan
							x="29.99" dy="1.2em" className="st6">Entity</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="9.64" y="981.9" className="st8" langid="1033">Load Serving <tspan
						x="29.99" dy="1.2em" className="st6">Entity</tspan></text>		</G>
		<G id="shape1275-1133" mid="1275" groupcontext="shape" layermember="7" transform="translate(1080,-259.835)">
			<title></title>
			<desc>&#60; represents</desc>
			
			
			<rect x="0" y="943.835" width="72" height="64.1645" className="st27" style={{fill: 'inherit'}} />
			<text x="-1006.41" y="39.6" transform="rotate(-90)" className="st53" langid="1033">&#60; represents</text>		</G>
		<G id="shape1276-1136" mid="1276" groupcontext="shape" layermember="5" transform="translate(951,-708.565)">
			<title></title>
			<path d="M-0 1019.7 L-0 1020.06 L-0 1033.73 L48 1033.73 L48 1080.98 L30 1080.98" className="st74"/>
		</G>
		<G id="shape1277-1144" mid="1277" groupcontext="shape" layermember="5" transform="translate(936,-646.835)">
			<title></title>
			<desc>represents &#62;</desc>
			
			
			<rect x="0" y="988" width="144" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1028.49" y="75.6" transform="rotate(-90)" className="st44" langid="1033">represents &#62;</text>		</G>
		<G id="shape1278-1147" mid="1278" groupcontext="shape" layermember="5" transform="translate(483,-552.335)">
			<title></title>
			<path d="M0 1008 L-0 886.5 L97.36 886.5 A3 3 0 1 1 103.36 886.5 L283.74 886.5 A3 3 0 0 1 289.74 886.5 L378 886.5 A3 3
						 0 1 1 384 886.5 L387 886.5 A3 3 0 1 1 393 886.5 L423 886.5 L423 913.5" className="st75"/>
		</G>
		<G id="shape1279-1154" mid="1279" groupcontext="shape" layermember="5" transform="translate(603,-671.511)">
			<title></title>
			<desc>transacts with &#62;</desc>
			
			
			<rect x="0" y="988" width="144" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="33.23" y="1001.6" className="st44" langid="1033">transacts with &#62;</text>		</G>
		<G id="shape1280-1157" mid="1280" groupcontext="shape" layermember="5" transform="translate(981,-620.96)">
			<title></title>
			<path d="M0 1015.87 L69 1015.87 A3 3 0 0 1 75 1015.87 L78 1015.87 A3 3 0 0 1 84 1015.87 L90 1015.87 L90 1018.12 L104.94
						 1018.12" className="st76"/>
		</G>
		<G id="shape1281-1165" mid="1281" groupcontext="shape" layermember="5" transform="translate(954,-592.835)">
			<title></title>
			<desc>represents &#62;</desc>
			
			
			<rect x="0" y="988" width="144" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="42.86" y="1001.6" className="st44" langid="1033">represents &#62;</text>		</G>
		<G id="shape1282-1168" mid="1282" groupcontext="shape" layermember="5" transform="translate(921,-601.835)">
			<title></title>
			<path d="M0 1008 L0 1053 L90 1053 A3 3 0 0 1 96 1053 L105 1053 A3 3 0 0 1 111 1053 L129 1053 A3 3 0 0 1 135 1053 L138
						 1053 A3 3 0 1 1 144 1053 L171 1053 L171 1157.94" className="st76"/>
		</G>
		<G id="shape1283-1175" mid="1283" groupcontext="shape" layermember="5" transform="translate(1026,-484.835)">
			<title></title>
			<desc>&#60; represents</desc>
			
			
			<rect x="0" y="988" width="144" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1028.49" y="75.6" transform="rotate(-90)" className="st44" langid="1033">&#60; represents</text>		</G>
		<G id="shape1284-1178" mid="1284" groupcontext="shape" layermember="8" transform="translate(1125,-495.835)" label="Bilateral Market" description="This is the process of having bilateral contracts between parties." >
			<title>Bilateral Market</title>
			<desc>Bilateral Market</desc>
			
				
			
			
			
			<G id="shadow1284-1179" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="963" width="90" height="45" className="st4" style={{fill: 'inherit'}} />
				<text x="23.32" y="981.9" className="st5" langid="1033">Bilateral <tspan
							x="26.66" dy="1.2em" className="st6">Market</tspan></text>			</G>
			<rect x="0" y="963" width="90" height="45" className="st7" style={{fill: 'inherit'}} />
			<text x="23.32" y="981.9" className="st8" langid="1033">Bilateral <tspan
						x="26.66" dy="1.2em" className="st6">Market</tspan></text>		</G>
		<G id="shape1285-1188" mid="1285" groupcontext="shape" layermember="5" transform="translate(951,-601.835)">
			<title></title>
			<path d="M0 1019.7 L0 1020.06 L0 1041.75 L60 1041.75 A3 3 0 0 1 66 1041.75 L75 1041.75 A3 3 0 1 1 81 1041.75 L99 1041.75
						 A3 3 0 1 1 105 1041.75 L108 1041.75 A3 3 0 1 1 114 1041.75 L189 1041.75 L189 1056.94" className="st77"/>
		</G>
		<G id="shape1286-1195" mid="1286" groupcontext="shape" layermember="5" transform="translate(1035,-565.835)">
			<title></title>
			<desc>can transact in &#62;</desc>
			
			
			<rect x="0" y="988" width="144" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="31.95" y="1001.6" className="st44" langid="1033">can transact in &#62;</text>		</G>
		<G id="shape1287-1198" mid="1287" groupcontext="shape" layermember="5" transform="translate(1152,-428.585)">
			<title></title>
			<path d="M11.7 1008 L12.06 1008 L48 1008 L48 952.81" className="st77"/>
		</G>
		<G id="shape1288-1205" mid="1288" groupcontext="shape" layermember="5" transform="translate(1161,-452.5)">
			<title></title>
			<desc>can transact in &#62;</desc>
			
			
			<rect x="0" y="988" width="72" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1027.82" y="32.4" transform="rotate(-90)" className="st44" langid="1033">can transact <tspan
						x="-1006.87" dy="1.2em" className="st6">in </tspan>&#62;</text>		</G>
		<G id="shape1289-1209" mid="1289" groupcontext="shape" layermember="5" transform="translate(966,-708.565)">
			<title></title>
			<path d="M0 1019.7 L0 1020.06 L0 1024.73 L57 1024.73 A3 3 0 0 1 63 1024.73 L84 1024.73 A3 3 0 0 1 90 1024.73 L93 1024.73
						 A3 3 0 1 1 99 1024.73 L174 1024.73 A3 3 0 1 1 180 1024.73 L234 1024.73 L234 1163.67" className="st77"/>
		</G>
		<G id="shape1290-1216" mid="1290" groupcontext="shape" layermember="5" transform="translate(1134,-588.5)">
			<title></title>
			<desc>&#60; can transact in</desc>
			
			
			<rect x="0" y="988" width="144" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1038.05" y="75.6" transform="rotate(-90)" className="st44" langid="1033">&#60; can transact in</text>		</G>
		<G id="shape1291-1219" mid="1291" groupcontext="shape" layermember="8" transform="translate(1251,-92)">
			<title></title>
			<desc>Title: ERCOT Industry Model (as built)</desc>
			
				
			
			
			
			<G id="shadow1291-1220" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="988" width="306" height="20" className="st4" style={{fill: 'inherit'}} />
				<text x="4" y="1001.6" className="st78" langid="1033">Title: ERCOT Industry Model (as built)</text>			</G>
			<rect x="0" y="988" width="306" height="20" className="st79" style={{fill: 'inherit'}} />
			<text x="4" y="1001.6" className="st28" langid="1033">Title: ERCOT Industry Model (as built)</text>		</G>
		<G id="shape1292-1227" mid="1292" groupcontext="shape" layermember="8" transform="translate(1251,-72)">
			<title></title>
			<desc>Drawn by: S. Pal</desc>
			
				
			
			
			
			<G id="shadow1292-1228" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="988" width="122.938" height="20" className="st4" style={{fill: 'inherit'}} />
				<text x="4" y="1001.6" className="st78" langid="1033">Drawn by: S. Pal</text>			</G>
			<rect x="0" y="988" width="122.938" height="20" className="st79" style={{fill: 'inherit'}} />
			<text x="4" y="1001.6" className="st28" langid="1033">Drawn by: S. Pal</text>		</G>
		<G id="shape1293-1235" mid="1293" groupcontext="shape" layermember="8" transform="translate(1373.94,-72)">
			<title></title>
			<desc>Version: 1</desc>
			
				
			
			
			
			<G id="shadow1293-1236" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="988" width="183.062" height="20" className="st4" style={{fill: 'inherit'}} />
				<text x="4" y="1001.6" className="st78" langid="1033">Version: 1</text>			</G>
			<rect x="0" y="988" width="183.062" height="20" className="st79" style={{fill: 'inherit'}} />
			<text x="4" y="1001.6" className="st28" langid="1033">Version: 1</text>		</G>
		<G id="shape1294-1243" mid="1294" groupcontext="shape" layermember="8" transform="translate(1251,-54)">
			<title></title>
			<desc>Date: 14 â€“ Jan â€“ 2019</desc>
			
				
			
			
			
			<G id="shadow1294-1244" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="990" width="306" height="18" className="st4" style={{fill: 'inherit'}} />
				<text x="4" y="1002.6" className="st78" langid="1033">Date: 14 â€“ Jan â€“ 2019</text>			</G>
			<rect x="0" y="990" width="306" height="18" className="st79" style={{fill: 'inherit'}} />
			<text x="4" y="1002.6" className="st28" langid="1033">Date: 14 â€“ Jan â€“ 2019</text>		</G>
		<G id="shape1295-1251" mid="1295" groupcontext="shape" layermember="8" transform="translate(1251,-36)">
			<title></title>
			<desc>Project: GMLC 1.2.1 Grid Architecture</desc>
			
				
			
			
			
			<G id="shadow1295-1252" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="990" width="306" height="18" className="st4" style={{fill: 'inherit'}} />
				<text x="4" y="1002.6" className="st78" langid="1033">Project: GMLC 1.2.1 Grid Architecture</text>			</G>
			<rect x="0" y="990" width="306" height="18" className="st79" style={{fill: 'inherit'}} />
			<text x="4" y="1002.6" className="st28" langid="1033">Project: GMLC 1.2.1 Grid Architecture</text>		</G>
		<G id="shape1296-1259" mid="1296" groupcontext="shape" layermember="3" transform="translate(226.74,-313.835)">
			<title></title>
			<desc>is a type of &#62;</desc>
			
			
			<path d="M0 1008 L0 1050 L88.26 1050 L88.26 1168.84 L253.26 1168.84 A3 3 0 1 1 259.26 1168.84 L301.26 1168.84 A3 3 0
						 0 1 307.26 1168.84 L337.26 1168.84 A3 3 0 1 1 343.26 1168.84 L634.26 1168.84 A3 3 0 1 1 640.26 1168.84 L787.26
						 1168.84 L787.26 888.46" className="st65"/>
			<rect rectcontext="textBkgnd" x="145.564" y="1152.64" width="61.7401" height="14.4001" className="st62" style={{fill: 'inherit'}} />
			<text x="145.56" y="1163.44" className="st49" langid="1033">is a type of &#62;</text>		</G>
		<G id="shape1298-1268" mid="1298" groupcontext="shape" layermember="7" transform="translate(513,-250.001)">
			<title></title>
			<path d="M0 1008.83 L15 1008.83 A3 3 0 1 1 21 1008.83 L51 1008.83 A3 3 0 1 1 57 1008.83 L132.3 1008.83 A3 3 0 1 1 138.3
						 1008.83 L162 1008.83 A3 3 0 1 1 168 1008.83 L225 1008.83 L225 1025.17 L235.09 1025.17" className="st80"/>
		</G>
		<G id="shape1299-1275" mid="1299" groupcontext="shape" layermember="7" transform="translate(639,-252.025)">
			<title></title>
			<path d="M0 1008 L6.35 1008 A3 3 0 1 1 12.35 1008 L24 1008 L24 1015.13" className="st81"/>
		</G>
		<G id="shape1300-1280" mid="1300" groupcontext="shape" layermember="7" transform="translate(513,-249.835)">
			<title></title>
			<desc>sells retail electricity to &#62;</desc>
			
			
			<rect x="0" y="988" width="133.5" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="6.01" y="1001.6" className="st53" langid="1033">sells retail electricity to &#62;</text>		</G>
		<G id="shape1301-1283" mid="1301" groupcontext="shape" layermember="7" transform="translate(876,-318.335)">
			<title></title>
			<path d="M0 1008 L0 1030.5 L-52.85 1030.5 A3 3 -180 0 0 -58.85 1030.5 L-223.85 1030.5 A3 3 -180 0 0 -229.85 1030.5 L-306
						 1030.5 A3 3 -180 0 0 -312 1030.5 L-342 1030.5 A3 3 -180 0 0 -348 1030.5 L-438 1030.5 L-438 1056.11"
					className="st80"/>
		</G>
		<G id="shape1302-1290" mid="1302" groupcontext="shape" layermember="7" transform="translate(415.5,-268.835)">
			<title></title>
			<desc>negotiate and purchase electricity from &#62;</desc>
			
			
			<rect x="0" y="970.472" width="250.5" height="37.5281" className="st27" style={{fill: 'inherit'}} />
			<text x="24.74" y="992.84" className="st53" langid="1033">negotiate and purchase electricity from &#62;</text>		</G>
		<G id="shape1303-1293" mid="1303" groupcontext="shape" layermember="7" transform="translate(483,-222.167)">
			<title></title>
			<path d="M0 1019.7 L0 1020.06 L0 1092.92 L45 1092.92 A3 3 0 0 1 51 1092.92 L81 1092.92 A3 3 0 1 1 87 1092.92 L378 1092.92
						 A3 3 0 0 1 384 1092.92 L626.25 1092.92 A3 3 0 0 1 632.25 1092.92 L644.25 1092.92 L644.25 1037.83"
					className="st82"/>
		</G>
		<G id="shape1304-1301" mid="1304" groupcontext="shape" layermember="7" transform="translate(856.5,-125.236)">
			<title></title>
			<desc>negotiate and purchase electricity from &#62;</desc>
			
			
			<rect x="0" y="970.472" width="250.5" height="37.5281" className="st27" style={{fill: 'inherit'}} />
			<text x="24.74" y="992.84" className="st53" langid="1033">negotiate and purchase electricity from &#62;</text>		</G>
		<G id="shape1305-1304" mid="1305" groupcontext="shape" layermember="3" transform="translate(605.375,-374.585)">
			<title></title>
			<path d="M0 1008 L-38.37 1008 L-38.37 1259.59 L258.63 1259.59 L258.63 1168.84 L312.62 1168.84" className="st65"/>
		</G>
		<G id="shape1306-1311" mid="1306" groupcontext="shape" layermember="3" transform="translate(641.25,-112.5)">
			<title></title>
			<desc>owns &#38; operates &#62;</desc>
			
			
			<rect x="0" y="975.5" width="132.75" height="32.5" className="st27" style={{fill: 'inherit'}} />
			<text x="20.66" y="995.35" className="st49" langid="1033">owns &#38; operates &#62;</text>		</G>
		<G id="shape1307-1314" mid="1307" groupcontext="shape" layermember="4" transform="translate(658.187,-363.335)">
			<title></title>
			<path d="M-7.81 1008 L-10.19 1138.5" className="st56"/>
		</G>
		<G id="shape1308-1321" mid="1308" groupcontext="shape" layermember="4" transform="translate(649.474,-313.827)">
			<title></title>
			<path d="M0 1008 L170.68 1008 L170.68 1079.99" className="st83"/>
		</G>
		<G id="shape1309-1326" mid="1309" groupcontext="shape" layermember="4" transform="translate(610.625,-313.835)">
			<title></title>
			<desc>&#60; deliver power to</desc>
			
			
			<rect x="0" y="970.472" width="79.5" height="37.5281" className="st27" style={{fill: 'inherit'}} />
			<text x="-1010.26" y="36.15" transform="rotate(-90)" className="st59" langid="1033">&#60; deliver <tspan
						x="-1011.45" dy="1.2em" className="st6">power to</tspan></text>		</G>
		<G id="shape1310-1330" mid="1310" groupcontext="shape" layermember="2" transform="translate(315,-853.835)">
			<title></title>
			<desc>registration with and reporting to &#62;</desc>
			
			
			<path d="M0 1008 L0 880.84 L828 880.84 L828 1216.44" className="st84"/>
			<rect rectcontext="textBkgnd" x="-1101.94" y="811.8" width="172.208" height="14.4001" transform="rotate(-90)"
					className="st62" style={{fill: 'inherit'}} />
			<text x="-1101.94" y="822.6" transform="rotate(-90)" className="st86" langid="1033">registration with and reporting to &#62;</text>		</G>
		<G id="shape1312-1341" mid="1312" groupcontext="shape" layermember="5" transform="translate(936,-352.085)">
			<title></title>
			<path d="M11.7 1008 L12.06 1008 L60 1008 A3 3 0 1 1 66 1008 L75 1008 A3 3 0 1 1 81 1008 L141 1008 L141 965.25"
					className="st87"/>
		</G>
		<G id="shape1314-1348" mid="1314" groupcontext="shape" layermember="5" transform="translate(1137,-394.835)">
			<title></title>
			<path d="M0 1008 L0 1069.84 L20.25 1069.84 L20.25 1153.44" className="st88"/>
		</G>
		<G id="shape1315-1355" mid="1315" groupcontext="shape" layermember="5" transform="translate(963,-247.5)">
			<title></title>
			<path d="M0 996.3 L0 995.94 L0 994.5 L-57 994.5 L-57 937.16" className="st87"/>
		</G>
		<G id="shape1316-1362" mid="1316" groupcontext="shape" layermember="5" transform="translate(859.5,-278)">
			<title></title>
			<desc>is a type of &#62;</desc>
			
			
			<rect x="0" y="988" width="90" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1005.95" y="41.4" transform="rotate(-90)" className="st44" langid="1033">is a <tspan
						x="-1019.56" dy="1.2em" className="st6">type of </tspan>&#62;</text>		</G>
		<G id="shape1317-1366" mid="1317" groupcontext="shape" layermember="5" transform="translate(1119.6,-286)">
			<title></title>
			<desc>is a type of &#62;</desc>
			
			
			<rect x="0" y="988" width="90" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1028.87" y="48.6" transform="rotate(-90)" className="st44" langid="1033">is a type of &#62;</text>		</G>
		<G id="shape1318-1369" mid="1318" groupcontext="shape" layermember="5" transform="translate(1008,-334.474)">
			<title></title>
			<desc>is a type of &#62;</desc>
			
			
			<rect x="0" y="988" width="90" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="14.13" y="1001.6" className="st44" langid="1033">is a type of &#62;</text>		</G>
		<G id="shape1319-1372" mid="1319" groupcontext="shape" layermember="7" transform="translate(1122,-394.835)">
			<title></title>
			<path d="M0 1008 L0 1143 L20.25 1143 L20.25 1165.5" className="st63"/>
		</G>
		<G id="shape1320-1379" mid="1320" groupcontext="shape" layermember="7" transform="translate(918,-236.25)">
			<title></title>
			<path d="M0 1008 L-63 1008 L-63 1082.25 L-300 1082.25 L-300 1059.47" className="st50"/>
		</G>
		<G id="shape1321-1386" mid="1321" groupcontext="shape" layermember="7" transform="translate(714.257,-162)">
			<title></title>
			<path d="M0 1008 L0 955.16 L33.84 955.16" className="st89"/>
		</G>
		<G id="shape1322-1391" mid="1322" groupcontext="shape" layermember="7" transform="translate(663.75,-156.835)">
			<title></title>
			<desc>&#60; provide wire services to</desc>
			
			
			<rect x="0" y="988" width="225" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="50.16" y="1001.6" className="st53" langid="1033">&#60; provide wire services to</text>		</G>
		<G id="shape1323-1394" mid="1323" groupcontext="shape" layermember="3" transform="translate(981,-742.315)">
			<title></title>
			<path d="M0 1008 L69 1008 A3 3 0 0 1 75 1008 L159 1008 A3 3 0 1 1 165 1008 L252 1008 L252 1344.23 L183.06 1344.23"
					className="st90"/>
		</G>
		<G id="shape1324-1401" mid="1324" groupcontext="shape" layermember="3" transform="translate(1162.53,-666)">
			<title></title>
			<desc>&#60; owns or controls</desc>
			
			
			<rect x="0" y="988" width="122.938" height="20" className="st27" style={{fill: 'inherit'}} />
			<text x="-1043.11" y="65.07" transform="rotate(-90)" className="st49" langid="1033">&#60; owns or controls</text>		</G>
	</G>
</svg>

            </div>
        );
    }
}
